<template xmlns:v-for="http://www.w3.org/1999/xhtml">
    <div class="d-flex flex-column">
        <b-container class="flex-grow-1 d-flex flex-column h-100" fluid>
            <!-- User Interface controls -->
            <b-collapse id="test" :visible="false">
              <yandex-map class="my-3"
                          :coords="[57.137170, 65.546001]"
                          zoom="12"
                          style="width: 10px; height: 10px;"
                          @map-was-initialized="backgroundMap" />
            </b-collapse>
            <b-row class="flex-grow-1">
                <b-col md="3" class="d-flex flex-column h-100">
                    <b-card no-body class="flex-grow-1 d-flex flex-column">
                        <b-tabs card v-model.number="tabIndex" class="flex-grow-1 d-flex flex-column h-100"
                                content-class="d-flex flex-column flex-grow-1 flex-tab">
                            <b-tab :title="brandsOptions[index].name" @click="catId = null"
                                   v-for="(index, item) in Object.keys(brandsOptions)" :key="item.id"
                                   class="px-0 py-0 flex-grow-1 h-100"
                                   :disabled="readonly === true && tabIndex !== parseInt(index)">
                                <b-list-group class="flex-shrink-0" flush>
                                    <b-list-group-item>
                                        <div class="categories">
                                            <template v-if="brandsOptions[tabIndex] !== undefined">
                                                <b-card no-body
                                                        v-for="category in Object.keys(brandsOptions[tabIndex].cats.nodes)"
                                                        :class="[{active : catId === category}, 'px-1', 'mb-1', 'justify-content-between']"
                                                        v-bind:key="category" class="text-center mx-1"
                                                        v-on:click="toggleCategory(category)">
                                                    <span>{{brandsOptions[tabIndex].cats.nodes[category].name}}</span>
                                                </b-card>
                                            </template>
                                        </div>
                                    </b-list-group-item>
                                </b-list-group>
                                <b-card-body class="flex-grow-1 d-flex flex-column pr-1 pl-0 pt-3">
                                    <div v-if="catId === null" class="text-center">Выберите категорию</div>
                                    <div v-if="catId !== null && countProds === 0" class="text-center">В выбранной категории нет товаров</div>
                                    <b-input-group class="pr-4 mb-2 pl-4 flex-shrink-0">
                                        <template v-if="countProds > 0">
                                            <b-form-input v-model="filterProd" class="brunch__text_input" placeholder="Введите для поиска"/>
                                            <transition name="slide-fade">
                                                <b-input-group-append v-if="filterProd.length">
                                                  <b-btn :disabled="!filterProd" @click="filterProd = ''">Очистить</b-btn>
                                                </b-input-group-append>
                                            </transition>
                                            <div class="mt-2 w-100"
                                                 v-if="filterProds !== null && filterProds.length === 0">Не
                                                найдено продуктов по фильтру
                                            </div>
                                        </template>
                                    </b-input-group>
                                      <perfect-scrollbar class="flex-basis-0 flex-grow-1 h-100" :options="opsScroll">
                                        <transition name="slide-fade-from-bottom">
                                          <b-card-group class="grid grid-3 products pr-4 pl-4 pb-1" id="products" v-if="countProds > 0">
                                                <b-card no-body class="text-center my-1 prod"
                                                        v-for="prod in filterProds" :key="prod.idProduct"
                                                        @click="addProd(prod)">
                                                    <div :id="'prod' + prod.idProduct"  v-b-tooltip.hover :title="prod.description"
                                                         class="px-1 py-1 d-flex flex-column h-100 justify-content-center">
                                                        <div>{{prod.name}}</div>
                                                        <div class="sub-info">{{prod.cost}} &#8381;</div>
                                                    </div>
                                                </b-card>
                                            </b-card-group>
                                        </transition>
                                    </perfect-scrollbar>
                                </b-card-body>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-col>
                <b-col :md="!ordersWindowVisibility ? 9 : 6" class="d-flex flex-column justify-content-between h-100">
                    <template v-if="loadingCheckOrderIndicator">
                      <b-card class="flex-grow-1" body-class="text-center d-flex flex-column justify-content-center">
                        <div>Проверка доступности заказа <b-spinner class="ml-1"></b-spinner></div>
                      </b-card>
                    </template>
                    <template v-else>
                      <template v-if="!order">
                          <b-card class="flex-grow-1" body-class="text-center d-flex flex-column justify-content-center">
                              <div>Выберите заказ или создайте новый</div>
                          </b-card>
                      </template>
                      <template v-if="order">
                          <b-card class="flex-grow-1 mb-1" :header-class="[readonly ? 'confirmOrder' : '']" no-body>
                              <h6 slot="header" class="d-flex justify-content-between align-items-center mb-0"><b>{{order.id
                                  ? 'Заказ #' + order.idDay : 'Новый заказ'}}:</b>
                                  <b-button @click="changeOrder()"
                                            class="px-2 py-0 pb-1 button-brunch"
                                            :disabled="this.loadingProducts"
                                            variant="danger">
                                      <icon name="times"></icon>
                                  </b-button>
                              </h6>
                              <b-list-group class="flex-grow-1 justify-content-between d-flex" flush id="orderProd">
                                  <perfect-scrollbar class="flex-basis-0 flex-grow-1" :options="opsScroll">
                                      <b-table hover
                                               show-empty
                                               :empty-text="emptyTextProds"
                                               :fields="fields"
                                               :items="orderProds"
                                               :busy="loadingProducts"
                                               tbody-class="scroll-y"
                                               class="mb-0 table-orders"
                                               tbody-tr-class="order-prods"

                                      >
                                          <template #table-busy>
                                            <div class="d-flex align-items-center justify-content-center mt-2">
                                              <b-spinner class="mr-2" type="border" variant="dark" small></b-spinner>
                                              <span>Загрузка...</span>
                                            </div>
                                          </template>
                                          <template slot="cost" slot-scope="data">
                                              <div v-if="!data.item.promocodeItem">
                                                  {{(data.item.cost > 0 || data.item.pricePoints === undefined || data.item.pricePoints === 0) ?
                                                  parseInt(data.item.cost) + ' Р' : data.item.pricePoints +
                                                  ' Б'}}
                                              </div>
                                              <div v-else>
                                                  <icon class="promocode-icon" name="gift"></icon>
                                              </div>
                                          </template>
                                          <template slot="summary" slot-scope="data">
                                              <div v-if="!data.item.promocodeItem">
                                                  {{(data.item.cost > 0 || data.item.pricePoints === undefined || data.item.pricePoints === 0) ?
                                                  summaryWithGroup(data.item) + ' Р' : summaryWithGroup(data.item, true) + ' Б'}}
                                              </div>
                                              <div v-else>
                                                  <icon class="promocode-icon" name="gift"></icon>
                                              </div>
                                          </template>
                                          <template slot="nameProd" slot-scope="data">
                                              <div :id="'orderProd' + data.item.index">
                                                  <div class="description">{{data.item.name}}</div>
                                                  <b-badge class="mr-1" v-for="add in data.item.groupProds"
                                                           :key="add.index">{{add.name}}{{add.cost > 0 ? ' (' + add.cost +
                                                      ' &#8381;)' : ''}}
                                                  </b-badge>
                                                  <b-form-checkbox
                                                          v-if="data.item.prod.pizzaSize || data.item.prod.burger"
                                                          class="checkbox-header"
                                                          :disabled="readonly"
                                                          v-model="data.item.smallSize"
                                                          :value="true"
                                                          @change="changedPositionSize(data.item)"
                                                          :unchecked-value="false">
                                                      {{data.item.prod.burger ? 'свинина' : 'на тонком тесте'}}
                                                  </b-form-checkbox>
                                              </div>
                                              <b-tooltip :target="'orderProd' + data.item.index" placement="right"
                                                         :title="data.item.prod.description"></b-tooltip>
                                          </template>
                                          <template slot="prodAdd" slot-scope="data">
                                              <b-button
                                                      v-if="allDop.get(data.item.prod ? data.item.prod.idCategory : data.item.idCategory)"
                                                      :disabled="readonly"
                                                      class="px-2 py-0 pb-1 round-btn" @click="openModalProducts(data.item)"
                                                      variant="info">
                                                  <icon name="plus"></icon>
                                              </b-button>
                                          </template>
                                          <template slot="countNum" slot-scope="data">
                                              <b-button class="px-2 py-0 pb-1 round-btn"
                                                        :disabled="(data.item.cost == 0 && data.item.pricePoints !== undefined) || readonly"
                                                        @click="changeProdCount(data.item, -1)"
                                                        variant="outline-danger">
                                                  <icon name="minus"></icon>
                                              </b-button>
                                              <b-form-input class="two-digit-inp align-middle"
                                                            :disabled="(data.item.cost == 0 && data.item.pricePoints !== undefined) || readonly"
                                                            v-model.number="data.item.count"
                                                            @input="changedProdCount(data.item)" type="number" min="0"
                                                            max="99"></b-form-input>
                                              <b-button class="px-2 py-0 pb-1 round-btn"
                                                        :disabled="(data.item.cost == 0 && data.item.pricePoints !== undefined) || readonly"
                                                        @click="changeProdCount(data.item, 1)"
                                                        variant="outline-success">
                                                  <icon name="plus"></icon>
                                              </b-button>
                                          </template>
                                          <template slot="delete" slot-scope="data">
                                              <b-button @click="delProd(data.item.index)"
                                                        class="px-2 py-0 pb-1 mr-2 button-brunch"
                                                        variant="danger">
                                                  <icon name="trash-alt"></icon>
                                              </b-button>
                                          </template>
                                      </b-table>
                                  </perfect-scrollbar>
                                  <add-additional-products
                                    :vuexNamespace="vuexNamespace"
                                    :product="productInEditing"
                                    :showed="openedModalAdditionalProducts"
                                    :allDops="allDop"
                                  ></add-additional-products>
                                  <b-list-group-item
                                          class="d-flex justify-content-between align-items-center flex-shrink-0 flex-wrap pt-1">
                                      <div class="w-100 d-flex justify-content-between align-items-center">
                                          <div class="priceOrder mr-2">
                                              <div>Итого: <b>{{orderPrice}} &#8381; {{orderPricePoints !== 0 ? '(' +
                                                  orderPricePoints + ' Б)' : ''}}</b> <span v-if="discountValue !== 0"> - <b>{{discountValue}} &#8381;</b>
                                                  <template v-if="order.discountType === 0"> (<b>{{order.discountValue}}%</b>)</template></span>
                                              </div>
                                              <div v-if="parseInt(order.clientPriceDelivery)">Доставка: <b>{{parseInt(order.clientPriceDelivery)}}
                                                  &#8381;</b></div>
                                              <div :key="getRealOrderPrice()">К оплате: <b>{{getRealOrderPrice()}} &#8381;</b></div>
                                          </div>
                                          <b-form-group label-size="sm" class="mb-1 mr-4" label="Скидка:">
                                              <b-form-select
                                                :value="orderTypeDiscount"
                                                :options="selectDiscount"
                                                :key="randomDiscountTypeUpdate"
                                                :disabled="collected"
                                                @change="setTypeDiscount($event)"
                                              >
                                              </b-form-select>
                                          </b-form-group>
                                          <b-form-group label-size="sm" class="mb-1 mr-4 flex-shrink-0"
                                                        label="Размер скидки:">
                                              <b-input type="number" placeholder="Размер скидки" min="0"
                                                       :disabled="order.discountType.keyword === constDiscount.POINTS || blockDiscountChange || collected"
                                                       v-model="order.discountValue"></b-input>
                                          </b-form-group>

                                          <b-form-group label-size="sm" class="mb-1 mr-4" label="Персон:">
                                              <b-input type="number" placeholder="Кол-во персон" :disabled="collected"
                                                       min="0"
                                                       v-model.number="order.personNumber"></b-input>
                                          </b-form-group>
                                          <b-form-group label-size="sm" class="mb-1" label="Время:">
                                              <el-time-select
                                                      :disabled="readonly"
                                                      class="inputSize w-100"
                                                      v-model="order.forTime"
                                                      format="HH:mm"
                                                      :picker-options="{
                                                      start: '9:00',
                                                      step: '00:15',
                                                      end: '23:45'
                                                  }"
                                                      placeholder="На время">
                                              </el-time-select>

                                          </b-form-group>
                                      </div>
                                      <div class="d-flex align-items-center justify-content-between w-100">

                                          <modal-add-payment @disable-not-correct-sum="disableConfirmByPayment"
                                                             @updatePaymentOnlyInfo="updatePaymentOnlyInfo"
                                                             @updateTypePaymentCombined="updateTypePaymentCombined"
                                                             :order="order" :orderSum="getRealOrderPrice()" :key="getRealOrderPrice()"
                                                             :readonly="readonly" :typesPayment="selectTypePayment"/>
                                          <b-form-group
                                                  label-size="sm"
                                                  label="Сдача с:"
                                                  label-class="mb-0"
                                                  class="mb-0 ml-2 change"
                                                  label-for="InputChange">
                                              <b-form-input id="InputChange"
                                                            :disabled="(order.typePayment.keyword !== constPayment.CASH && order.typePayment.keyword !== constPayment.COMBO) || readonly"
                                                            class=""
                                                            type="number"
                                                            min="0"
                                                            v-model="order.change"
                                                            required
                                                            placeholder="Сдача с">
                                              </b-form-input>
                                          </b-form-group>
                                          <b-form-group
                                                  label-size="sm"
                                                  label="Промокод:"
                                                  class="mb-0 ml-2 flex-grow-1">
                                              <v-select @change="selectPromocode" v-model="orderPromocode" :disabled="readonly"
                                                        label="title" :options="promocodeOptions" :key="randomPromocodeUpdate">
                                                        <template v-slot:option="option">
                                                          <div v-html="option.title" :class="[{'promocodeOnlyMobile': option.onlyMobile}]"></div>
                                                        </template>
                                                  <span slot="no-options">Не найдено</span>
                                              </v-select>
                                          </b-form-group>
                                          <b-form-group label-size="sm" class="mb-0 ml-2 flex-grow-0" label="День:">
                                              <el-date-picker
                                                      :disabled="readonly"
                                                      value-format="yyyy-MM-dd"
                                                      format="dd.MM.yyyy"
                                                      v-model="order.forDay"
                                                      :picker-options="datePickerOptions"
                                                      type="date"
                                                      placeholder="Выбрать день">
                                              </el-date-picker>
                                          </b-form-group>

                                      </div>
                                      <div class="d-flex w-100">
                                          <b-form-group
                                                  label="Комментарий курьеру:"
                                                  class="mb-0 flex-grow-1 mt-2 w-100"
                                                  label-for="InputComment">
                                              <b-form-input id="InputComment"
                                                            class=""
                                                            v-model="order.comment"
                                                            required
                                                            placeholder="Комментарий курьеру">
                                              </b-form-input>
                                          </b-form-group>
                                          <b-form-group
                                                  label="Комментарий на кухню:"
                                                  class="mb-0 flex-grow-1 mt-2 w-100 ml-2"
                                                  label-for="InputKitchenComment">
                                              <b-form-input id="InputKitchenComment"
                                                            class=""
                                                            v-model="order.kitchenComment"
                                                            required
                                                            placeholder="Комментарий на кухню">
                                              </b-form-input>
                                          </b-form-group>
                                      </div>

                                  </b-list-group-item>
                              </b-list-group>
                          </b-card>
                          <b-row class="flex-shrink-0">
                              <b-col md="7">

                                  <b-card no-body class="my-1" :header-class="[readonly ? 'confirmOrder' : '']">
                                      <h6 slot="header" class="d-flex justify-content-between align-items-center mb-0"><b>Доставка:
                                          ({{priceDel}})</b>
                                          <b-form-checkbox id="checkbox1" class="checkbox-header"
                                                           v-model.number="order.typeDelivery"
                                                           :value="deliveryOptions.find(el => el.keyword === constDelivery.PICKUP)"
                                                           :unchecked-value="deliveryOptions.find(el => el.keyword === constDelivery.DELIVERY)">
                                              Самовывоз
                                          </b-form-checkbox>
                                      </h6>
                                      <b-list-group flush>
                                          <b-list-group-item>
                                              <b-row>
                                                <b-col md="12">
                                                      <b-form-group id="InputGroup1"
                                                        label-size="sm"
                                                        class="mb-1"
                                                        label-class="mb-0"
                                                        label="Населённый пункт:"
                                                        label-for="Input0">
                                                          <input
                                                            v-model="order.city"
                                                            type="text"
                                                            class="form-control"
                                                            :disabled="!allowEditAddress"
                                                          />
                                                      </b-form-group>
                                                  </b-col>
                                                  <b-col md="12">
                                                      <b-form-group id="InputGroup1"
                                                                    label-size="sm"
                                                                    class="mb-1"
                                                                    label-class="mb-0"
                                                                    label="Улица:"
                                                                    label-for="Input1">
                                                          <vue-bootstrap-typeahead
                                                                  :value="createAddressQuery()"
                                                                  :maxMatches="3"
                                                                  :disabled="!allowEditAddress"
                                                                  :data="possibleStreets"
                                                                  :inputClass="streetError && 'border border-danger mb-1'"
                                                                  placeholder="Введите улицу"
                                                                  @input="onInputAddress"
                                                                  @focus="onInputAddress"
                                                                  @hit="onAddressHit"
                                                          />
                                                          <div v-if="streetError" class="street-error">{{streetError}}</div>
                                                      </b-form-group>
                                                  </b-col>
                                                  <!-- <b-col md="4">
                                                      <b-form-group id="InputGroup2"
                                                                    label-size="sm"
                                                                    class="mb-1"
                                                                    label="Дом:"
                                                                    label-class="mb-0"
                                                                    label-for="Input2">
                                                          <b-form-input id="Input2"
                                                                        :disabled="!allowEditAddress"
                                                                        v-model="order.house"
                                                                        required
                                                                        placeholder="Дом">
                                                          </b-form-input>
                                                      </b-form-group>
                                                  </b-col> -->
                                              </b-row>
                                              <b-row>
                                                  <b-col md="3">
                                                      <b-form-group id="InputGroup3"
                                                                    label-size="sm"
                                                                    class="mb-1"
                                                                    label="Подъезд:"
                                                                    label-class="mb-0"
                                                                    label-for="Input3">
                                                          <b-form-input id="Input3"
                                                                        :disabled="!allowEditAddress"
                                                                        v-model="order.entrance"
                                                                        required
                                                                        placeholder="Подъезд">
                                                          </b-form-input>
                                                      </b-form-group>
                                                  </b-col>
                                                  <b-col md="3">
                                                      <b-form-group id="InputGroup4"
                                                                    label-size="sm"
                                                                    class="mb-1"
                                                                    label="Этаж:"
                                                                    label-class="mb-0"
                                                                    label-for="Input4">
                                                          <b-form-input id="Input4"
                                                                        :disabled="!allowEditAddress"
                                                                        v-model="order.floor"
                                                                        required
                                                                        placeholder="Этаж">
                                                          </b-form-input>
                                                      </b-form-group>
                                                  </b-col>

                                                  <b-col md="3">
                                                      <b-form-group id="InputGroup5"
                                                                    label-size="sm"
                                                                    class="mb-1"
                                                                    label="Кв:"
                                                                    label-class="mb-0"
                                                                    label-for="Input5">
                                                          <b-form-input id="Input5"
                                                                        :disabled="!allowEditAddress"
                                                                        v-model="order.apartment"
                                                                        required
                                                                        placeholder="Квартира">
                                                          </b-form-input>
                                                      </b-form-group>
                                                  </b-col>
                                                  <b-col md="3">
                                                      <b-form-group id="InputGroup6"
                                                                    label-size="sm"
                                                                    class="mb-1"
                                                                    label="Офис:"
                                                                    label-class="mb-0"
                                                                    label-for="Input6">
                                                          <b-form-input id="Input6"
                                                                        :disabled="!allowEditAddress"
                                                                        v-model="order.office"
                                                                        required
                                                                        placeholder="Офис">
                                                          </b-form-input>
                                                      </b-form-group>
                                                  </b-col>
                                              </b-row>
                                          </b-list-group-item>
                                      </b-list-group>
                                  </b-card>
                              </b-col>
                              <b-col md="5" class="d-flex flex-column">
                                  <b-card no-body header-tag="b" header="Клиент:" class="my-1"
                                          :header-class="[readonly ? 'confirmOrder' : '']">
                                    <div slot="header" class="d-flex justify-content-between align-items-center">
                                      <b>Клиент:</b>
                                      <client-info-with-open-button @update:client-order="changeClient($event)" :clientIdent="clientIdent"></client-info-with-open-button>
                                    </div>
                                    <b-list-group flush>
                                        <b-list-group-item>
                                            <template v-if="order.client">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <span>{{order.client && order.client.name ? order.client.name : 'Не указано'}}</span><span>{{order.client ? order.client.phone : ''}}</span>
                                                    <b-button v-if="order.id === null"
                                                              @click="order.phone = order.phone.substr(0, order.phone.length - 1)"
                                                              class="px-2 py-0 pb-1"
                                                              variant="info">
                                                        <icon name="edit"></icon>
                                                    </b-button>
                                                </div>
                                            </template>
                                            <template
                                                    v-else-if="!order.client && (!order.phone || order.phone.length < 17 || (order.phone.length >= 2 && (order.phone[3] !== '9' && order.phone[3] !== '3')))">
                                                <div class="d-flex justify-content-between">
                                                    <b-form-input v-model="order.fio" :disabled="readonly"
                                                                  placeholder="Имя" class="mr-2"></b-form-input>
                                                    <the-mask :masked="true" :disabled="readonly"
                                                              mask="8 (###) ###-##-##" class="pl-2 pr-2 mr-2"
                                                              v-model="order.phone" placeholder="8 (###) ##-##-##"/>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div v-if="!order.client && order.phone && order.phone.length == 17"
                                                      class="d-flex justify-content-between align-items-center">
                                                    <span>{{order.fio ? order.fio : 'Не указано'}} (Не авториз.)</span><span>{{ order.phone}}</span>
                                                    <b-button v-if="!readonly"
                                                              class="px-2 py-0 pb-1"
                                                              @click="order.phone = order.phone.substr(0, order.phone.length - 1)"
                                                              variant="info">
                                                        <icon name="edit"></icon>
                                                    </b-button>
                                                </div>
                                            </template>
                                        </b-list-group-item>
                                    </b-list-group>
                                  </b-card>
                                  <b-card no-body class="my-1" :header-class="[readonly ? 'confirmOrder' : '']">
                                      <div slot="header" class="d-flex justify-content-between align-items-center">
                                          <b>Точка:</b>
                                          <b-button
                                                  :disabled="readonly && this.order.ymapsDistance !== null || this.order.typeDelivery && this.order.typeDelivery.keyword === constDelivery.PICKUP || order.street.length === 0"
                                                  v-b-modal.deliveryMap
                                                  size="sm"
                                                  class="px-2 py-0 pb-1"
                                                  variant="info">
                                              Определить
                                          </b-button>
                                      </div>
                                      <b-list-group flush>
                                          <b-list-group-item>
                                            <v-select v-model="order.point"
                                              label="address"
                                              :options="branchOptions"
                                              append-to-body
                                              :calculate-position="withPopper"
                                            >
                                              <template v-slot:option="option">
                                                <div v-html="option.address"></div>
                                              </template>
                                              <span slot="no-options">Не найдено</span>
                                            </v-select>
                                          </b-list-group-item>
                                      </b-list-group>
                                  </b-card>
                              </b-col>
                          </b-row>
                      </template>
                    </template>
                    <div class="d-flex flex-shrink-0 justify-content-between">
                        <b-btn class="flex-grow-1 mt-2" :disabled="loadingOrders" variant="outline-primary"
                               @click="changeOrder(copyObj(emptyOrder))">Новый заказ
                        </b-btn>
                        <b-btn v-if="permitCancelOrder && !isRestManager" class="flex-grow-1 ml-1  mt-2" variant="danger"
                               :disabled="!order || !order.id || loadingOrders" @click="cancelOrder">Отменить
                        </b-btn>
                        <b-btn v-if="readonly && permitCancelOrder && !isRestManager" :disabled="loadingOrders" class="flex-grow-1 ml-1  mt-2" variant="warning"
                               @click="cancelOrderRepeat()">Отменить и повторить
                        </b-btn>
                        <b-btn :disabled="loadingOrders" v-if="readonly && permitCancelOrder && this.order.priority === 0"
                               @click="importantOrder(order)" class="flex-grow-1 ml-1  mt-2">Срочно!
                        </b-btn>
                        <b-btn :disabled="loadingOrders" v-if="(readonly && !permitCancelOrder) || (readonly && permitCancelOrder)"
                               class="flex-grow-1 ml-1  mt-2" variant="warning"
                               @click="changeOrderRep(order, order.id)">Повторить
                        </b-btn>
                        <b-btn v-if="permitCancelOrder" class="flex-grow-1 ml-1  mt-2" variant="success"
                               :disabled="!this.order || !permitSaveOrder || disableConfirmPayment || loadingOrders || orderInProcessOfSaving"
                               @click="editOrder()">{{readonly ? 'Сохранить' : 'Подтвердить'}}<b-spinner v-if="orderInProcessOfSaving" small class="ml-1"></b-spinner>
                        </b-btn>
                    </div>
                </b-col>
                <b-col md="3" class="d-flex flex-column h-100" v-if="ordersWindowVisibility">
                    <b-card no-body class="flex-grow-1 overflow-hidden" header-class="py-2">
                        <div slot="header" class="d-flex justify-content-between align-items-center">
                            <div class='orders-count-title' v-b-tooltip.hover title="Отобразить все заказы" @click="showAllOrders">
                              <b>Заказы <span id="orders-length">{{filterOrds.length}}</span> из <span id="orders-total-length">{{ordersCount}}</span>:</b>
                            </div>
                            <span>
                                <el-button
                                  class="no-outline"
                                  v-b-toggle.collapseOrders
                                  icon="el-icon-search"
                                  size="medium" circle>
                                </el-button>
                                <el-button
                                  class="no-outline"
                                  icon="el-icon-refresh"
                                  size="medium"
                                  v-b-tooltip.hover.topleft
                                  title="Обновить список заказов"
                                  circle
                                  @click="forceReloadOrders">
                                </el-button>
                                <el-button
                                  class="no-outline"
                                  v-b-modal.listOrders
                                  icon="el-icon-tickets"
                                  type="primary"
                                  size="medium"
                                  circle>
                                </el-button>
                            </span>
                        </div>
                        <b-collapse id="collapseOrders">
                            <b-list-group flush>
                                <b-list-group-item>
                                    <b-form-group horizontal label="Поиск" class="mb-1">
                                        <b-input-group>
                                            <b-form-input v-model="filterOrders" class="brunch__text_input" placeholder="Введите для поиска"/>
                                            <transition name="slide-fade">
                                                <b-input-group-append v-if="filterOrders.length">
                                                  <b-btn :disabled="!filterOrders" @click="filterOrders = ''">Очистить</b-btn>
                                                </b-input-group-append>
                                            </transition>
                                        </b-input-group>
                                    </b-form-group>
                                    <b-form-group horizontal label="Статус" class="mb-1">
                                        <b-form-select :disabled="loadingOrders" v-model="filterStatus" @change="statusUpdated($event)" :options="selectStatuses">
                                            <option slot="first" :value="null">-- Все --</option>
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-group horizontal label="Точка" class="mb-1" v-if="selectPoints">
                                        <b-form-select :disabled="loadingOrders" :value="filterBranch" @change="restPointUpdated($event)" :options="selectPoints">
                                            <option slot="first" :value="null">-- Все --</option>
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-checkbox
                                            id="checkbox-preorders"
                                            v-model="showPreordersToday"
                                            name="checkbox-preorders"
                                            :value="true"
                                            :unchecked-value="false"
                                            :disabled="loadingOrders"
                                    >
                                        Отображать предзаказы оформленные сегодня
                                    </b-form-checkbox>
                                  <b-form-checkbox
                                      id="checkbox-preorders-week"
                                      v-model="showPreordersWeek"
                                      name="checkbox-preorders-week"
                                      :value="true"
                                      :unchecked-value="false"
                                      :disabled="loadingOrders"
                                    >
                                      Отображать предзаказы на ближайшую неделю
                                    </b-form-checkbox>
                                  <b-form-checkbox
                                    id="checkbox-order-done"
                                    v-model="showDoneOrder"
                                    name="checkbox-order-done"
                                    :value="true"
                                    :unchecked-value="false"
                                    :disabled="loadingOrders"
                                  >
                                    Отображать завершенные заказы
                                  </b-form-checkbox>
                                </b-list-group-item>
                            </b-list-group>
                        </b-collapse>
                        <preloader v-if="reloadingOrders === true"/>
                        <perfect-scrollbar @ps-scroll-y="onOrdersScroll" ref="scrollbar" class="flex-grow-1 flex-basis-0" :options="opsScroll">
                            <b-list-group class="mb-1" flush ref="orders_list">
                                <b-card-body class="text-center" v-if="filterOrds.length === 0 && !loadingOrders">Заказов не найдено
                                </b-card-body>
                                <b-list-group-item
                                  v-for="(ord, idx) in filterOrds"
                                  :key="ord.id"
                                  @click="changeOrder(ord)"
                                  :class="[
                                    'order',
                                    {activeIt: order && ord.id === order.id},
                                    {
                                      'busy-order': ord.idWorkerOpened !== null
                                        && ord.timeOpened !== null
                                        && secondsFromNow(ord.timeOpened) < holdTime,
                                      'opened-by-me-order': ord.idWorkerOpened !== null
                                        && ord.idWorkerOpened === userId
                                        && ord.timeOpened !== null
                                        && secondsFromNow(ord.timeOpened) < holdTime
                                    }
                                  ]"
                                >
                                    <order-block
                                      :order="ord"
                                      :key="ord.id"
                                      type="call-center"
                                      @shown-hide-order="shownHideOrder($event)"
                                      @on-history-show="addStatusesToOrder(ord, idx)"
                                    >
                                    </order-block>
                                </b-list-group-item>
                            </b-list-group>
                        <div class="d-flex align-items-center justify-content-center mt-2" v-if="loadingOrders === true">
                          <b-spinner class="mr-2" type="border" variant="dark" small></b-spinner>
                          <span>Загрузка...</span>
                        </div>
                        </perfect-scrollbar>
                    </b-card>
                    <b-modal modal-class="fullSizeModal" @shown="$refs.listOrdersComp.updateOrders()" ref="listOrders"
                             ok-only id="listOrders" size="lg">
                        <list-orders ref="listOrdersComp" :statusOptions="statusOptions"
                                     @repeat-order="repeatFromHistory($event)" class="body"/>
                    </b-modal>
                    <b-modal v-if="order" modal-class="fullSizeModal"
                             cancel-title="Зона определена не верно"
                             @close="closeModal"
                             @hide="closeModal"
                             @shown="findPlace"
                             title="Определение точки доставки" ref="ymapsModal" id="deliveryMap" size="lg">
                        <div v-if="loadingSuggest"><b-spinner type="grow" ></b-spinner> Загрузка...</div>
                        <div
                          v-if="!loadingSuggest && variantsPositions.length === 0"
                          class="info-suggest-not-found"
                        >
                          Указанной улицы не найдено ни в одном населённом пункте<br>
                          Проверьте правильность ввода.
                        </div>
                        <div
                          v-if="suggestError"
                          class="info-suggest-error"
                        >
                          Ошибка при поиске улицы, закройте и откройте заново окно определения местоположения.
                        </div>
                        <perfect-scrollbar class="scroll-postiton-variants" :options="opsScroll">
                          <card-location-variant
                              v-for="pos in variantsPositions"
                              :key="pos.sourceValue"
                              :variant="pos"
                              :selected-variant="selectedPosition"
                              @selected-variant="selectedPosition = $event"
                          />
                        </perfect-scrollbar>
                        <div
                          class="mb-2 mt-2 delivery-cost"
                          :class="{
                            'delivery-cost_error': this.order.idZone === null,
                            'delivery-cost_success': this.order.idZone !== null
                          }"
                        >
                          <div><b>Стоимость доставки:</b> {{priceDel}}</div>
                          <div><b>Точка:</b> {{order.point ? order.point.address : 'Не определена'}}</div>
                          <div><b>Населенный пункт:</b> {{order.settlement ? order.settlement : 'Не определен'}}</div>
                        </div>
                        <b-button :class="ymapsToggled ? null : 'collapsed'" :aria-expanded="ymapsToggled ? 'true' : 'false'" aria-controls="map" @click="ymapsToggled = !ymapsToggled">Открыть карту</b-button>
                        <b-button @click="createRouteMatrixAndDetermineDistance()" v-if="courierAutoAssignStatus === true && ymapsToggled">Построить маршрут</b-button>
                        <b-collapse id="map" v-model="ymapsToggled">
                          <yandex-map class="my-3"
                                      :coords="ymapsCoords.dynamic"
                                      zoom="12"
                                      style="width: 100%; height: 550px;"
                                      @map-was-initialized="mapInitHandler"
                                      :cluster-options="{
                                  1: {clusterDisableClickZoom: true}
                                }"
                                      :controls="['trafficControl', 'zoomControl', 'searchControl', 'routePanelControl']"
                                      :detailed-controls="{ searchControl: { provider: yandexSearchProvider } }"
                          />

                        </b-collapse>
                        <template slot="modal-footer">
                          <b-button
                            v-if="!this.permitDragPoint"
                            variant="danger"
                            @click="permitMovePoint"
                          >Зона определена не верно</b-button>
                          <span id="zone-correct" class="d-inline-block" tabindex="0">
                            <b-button
                            variant="success"
                            @click="$bvModal.hide('deliveryMap')"
                            :disabled="this.courierAutoAssignStatus === true && this.ymapsMatrixCreated === false"
                          >Зона определена верно</b-button>
                          </span>
                          <b-tooltip target="zone-correct">Чтобы эта кнопка была активной, нужно: <br>1. Открыть карту; <br>2. Построить маршрут</b-tooltip>
                        </template>
                    </b-modal>
                </b-col>
            </b-row>
        </b-container>
        <b-modal id="warningMutation" centered ref="warningMutation" :visible="showWarningModal"
            ok-title="Да" cancel-title="Нет" ok-variant="danger" cancel-variant="success" @ok="warningModalResult(true)" @cancel="warningModalResult(false)">
          {{warningModalObject ? warningModalObject.text : ''}}
        </b-modal>
        <b-modal id="confirmOrder" title="Предупреждение" centered ref="confirmOrder" cancel-title="Отмена"
                 ok-title="Продолжить" @ok="setOrder(nextOrder)">
            Заказ был изменён. Совершённые изменения будут утеряны, продолжить?
        </b-modal>
        <b-modal id="anotherOperatorActive" title="Ошибка" centered ref="anotherOperatorActive"
                ok-only>
          Другой оператор уже обрабатывает выбранный заказ
        </b-modal>
        <b-modal id="prohibitChangeOrder" title="Предупреждение" centered ref="prohibitChangeOrder" cancel-title=""
                 ok-title="ОК" :ok-only="true">
            Выбранный заказ уже был подтверждён, его изменение запрещено.
        </b-modal>
        <b-modal v-if="order" id="orderDeleteProduct" title="Вы действительно хотите удалить продукты из заказа?"
                 :ok-disabled="order.deletedComment === null ||order.deletedComment === ''" centered
                 ref="orderDeleteProduct" cancel-title="Отмена" @ok="saveOrder()"
                 ok-title="ОК">
            <b-form-group
                    label="Введите причину удаления продуктов:"
                    class="mb-0 flex-grow-0"
                    label-for="deletedCause">
                <b-form-input id="deletedCause"
                              v-model="order.deletedComment"
                              class=""
                              required
                              trim
                              placeholder="Комментарий">
                </b-form-input>
            </b-form-group>
        </b-modal>
        <cancel-order-modal
          v-if="!isRestManager"
          ref="causeCancelOrder"
          :orderId="order ? order.id : null"
          :onWorkshopNow="order ? order.workshop && order.workshop.nodes && order.workshop.nodes.length > 0 : false"
          :statusOptions="statusOptions"
          :repeat="repeat"
          @order-canceled="orderCanceled">
        </cancel-order-modal>
    </div>
</template>

<script>
import ClientInfoWithOpenButton from './containers/ClientInfoWithOpenButton'
import commonVar from '@/tempVariables/commonVars'
import orderFunc from '@/functionsLib/orderFunc'
import ListOrders from '@/components/ListOrders'
import ModalAddPayment from './ModalAddPayment'
import queries from '../constants/graphqlOrderManagment'
import CancelOrderModal from './modals/CancelOrder'
import lodash from 'lodash'
import {callCenterMUT} from '../constants/vuexMutations'
import { createPopper } from '@popperjs/core'
import {
  ACTIVE_BRANDS_QUERY,
  TYPE_PAYMENT_QUERY,
  TYPE_DELIVERY_QUERY,
  DELIVERY_ZONES,
  REST_POINT_QUERY,
  STATUS_QUERY,
  ALL_PRODUCTS_QUERY,
  SEARCH_ADD_PRODS_QUERY,
  UPDATE_ORDER_MUTATE,
  UPDATE_COMBO_PAYMENT,
  SOFT_DELETE_ORDER,
  SH_FIND_TARGET_RESTOURANT,
  TYPE_WORKSHOPS,
  TYPE_STAGE_WORKSHOPS
} from '@/constants/graphql'
import {
  TYPE_DELIVERY,
  TYPE_PAYMENT,
  TYPE_DISCOUNT,
  STATUS_ORDER
} from '@/constants/keywords'
import {callCenterACT} from '../constants/vuexActions'
import {callCenterGetters} from '../constants/vuexGetters'
import commonForOrders from '../graphql/commonForOrders'
import AddAdditionalProducts from './modals/AddAdditionalProducts'
import {callCenterVars} from '../constants/vuexVariables'
import ordersMeta from '../graphql/ordersMeta'
import CardLocationVariant from './CardLocationVariant'
import Vue from 'vue'
import Preloader from './Preloader.vue'
import VueBootstrapTypeahead from './VueBootstrapTypeahead.vue'
import { yandexSearchProvider as yandexSearchProviderModule } from '@/helpers/yandexSearchControlProvider'

export default {
  name: 'OrderInfo',
  components: {
    AddAdditionalProducts,
    ClientInfoWithOpenButton,
    ModalAddPayment,
    ListOrders,
    CancelOrderModal,
    CardLocationVariant,
    Preloader,
    VueBootstrapTypeahead
  },
  mounted () {
    this.fetchOrders()

    this.intervalCheckNewOrders = setInterval(() => {
      if (this.$userControl.isOnline === true && this.ordersWindowVisibility) {
        this.checkNewOrders()
      }
    }, 10 * 1000)

    this.intervalCheckExistingOrders = setInterval(() => {
      if (this.$userControl.isOnline === true && this.ordersWindowVisibility) {
        this.checkExistingOrders()
      }
    }, 10 * 1000)
  },
  beforeDestroy () {
    clearInterval(this.intervalPromocodes)
    clearInterval(this.intervalCheckNewOrders)
    clearInterval(this.intervalCheckExistingOrders)
  },
  data: function () {
    return {
      ymapsToggled: false,
      ymapsCoords: {
        default: [57.137170, 65.546001],
        dynamic: [57.137170, 65.546001]
      },
      ymapsMatrixCreated: false,
      lastOrder: null,
      placement: 'top',
      ordersWindowVisibility: true,
      ordersRef: [],
      orderInProcessOfSaving: false,
      reloadingOrders: false,
      ordersInProgressUpdate: [],
      yandexError: false,
      intervalPromocodes: null,
      openedModalSuggest: false,
      suggestError: false,
      loadingSuggest: false,
      streetWasChanged: true,
      selectedPosition: null,
      variantsPositions: [],
      geocodingRectangle: [[57.256787, 65.368925], [56.974940, 66.020702]],
      listOrders: [],
      randomPromocodeUpdate: Math.floor(Math.random() * 1000),
      randomDiscountTypeUpdate: Math.floor(Math.random() * 1000),
      modalAdditionalProductsOpened: false,
      intervalCheckNewOrders: null,
      intervalCheckExistingOrders: null,
      loadingCheckOrderIndicator: false,
      vuexNamespace: 'callCenter',
      loadingGeocodePlace: false,
      promocodes: [],
      cancelCause: '',
      repeat: false,
      selectedBranch: null,
      selectTypePayment: [],
      selectPoints: [],
      selectBrands: [],
      selectStatuses: [],
      selectPreorder: [],
      disableConfirmPayment: false,
      testQuery: [],
      showPreordersToday: false,
      showPreordersWeek: false,
      showDoneOrder: false,
      nextOrder: null,
      constDelivery: TYPE_DELIVERY,
      constPayment: TYPE_PAYMENT,
      constDiscount: TYPE_DISCOUNT,
      constStatus: STATUS_ORDER,
      filterProd: '',
      filterOrders: '',
      searchQuery: '',
      filterStatus: null,
      filterBranch: null,
      selectedProd: null,
      trueVar: true,
      tabIndex: 0,
      catId: null,
      emptyTextProds: 'Добавьте продукты в заказ',
      statusOptions: [],
      paymentOptions: [],
      branchOptions: [],
      brandsOptions: [],
      pointsIndex: new Map(),
      products: [],
      deliveryOptions: [],
      discountOptions: [],
      deliveryZones: [],
      possibleStreets: [],
      ops: commonVar.opsVueScroll,
      opsScroll: commonVar.opsPerfectScroll,
      order: null,
      oldOrder: null,
      preparedOrder: null,
      filterClient: null,
      // allProds: [],
      allDop: new Map(),
      ymap: null,
      deliveryPoint: null,
      zones: null,
      zonesModal: null,
      activePol: {
        pol: null,
        color: null
      },
      permitDragPoint: false,
      fields: [
        {
          key: 'index',
          label: '№'
        },
        {
          class: 'table-prod-name',
          key: 'nameProd',
          label: 'Товар'
        },
        {
          key: 'prodAdd',
          label: 'Доп.'
        },
        {
          key: 'countNum',
          label: 'Кол-во',
          class: 'text-center'
        },
        {
          key: 'cost',
          label: 'Цена',
          class: 'text-right'
        },
        {
          key: 'summary',
          label: 'Стоимость',
          class: 'text-right'
        },
        {
          key: 'delete',
          label: '',
          class: 'text-right'
        }
      ],
      orders: [],
      emptyOrder: {
        'id': null,
        'typePayment': {'id': 1, 'name': 'Наличными', 'keyword': 'cash', '__typename': 'TypePayment'},
        'typeDelivery': {'id': 2, 'name': 'Доставка', 'keyword': 'delivery', '__typename': 'TypeDelivery'},
        'discountType': {
          'id': 0,
          'name': 'Без скидки',
          'keyword': 'without',
          'comment': '',
          'active': true,
          'defaultValue': 0,
          '__typename': 'TypeDiscount'
        },
        'coords': null,
        'change': null,
        'forDay': this.$moment().format('YYYY-MM-DD'),
        'prods': {'nodes': []},
        'street': '',
        'house': '',
        'entrance': '',
        'floor': '',
        'office': '',
        'discountValue': 0,
        'time': this.$moment(),
        'fio': '',
        'personNumber': null,
        'comment': null,
        'kitchenComment': null,
        'price': '0',
        'pricePoints': '0',
        'payment': false,
        'priceDelivery': null,
        'clientPriceDelivery': null,
        'status': {
          'id': 1,
          'name': 'Новый',
          'keyword': 'new'
        },
        precision: null,
        selectedPosition: null,
        point: null
      },
      datePickerOptions: {
        firstDayOfWeek: 1,
        disabledDate (date) {
          let newDate = new Date()
          newDate.setDate(newDate.getDate() - 1)
          return date < newDate
        }
      },
      page: 0,
      existMore: true,
      loadingOrders: false,
      loadingNewOrders: false,
      loadingProducts: false,
      addedNewOrder: false,
      lastId: null,
      ordersCount: 0,
      addressesData: {},
      streetError: ''
    }
  },
  apollo: {
    promocodes: {
      query: ordersMeta.LIST_PROMOCODES,
      update (data) {
        let itemsPromocode = []
        data.getActivePromocodes.nodes.forEach(item => {
          itemsPromocode.push(item)
        })
        return itemsPromocode
      }
    },
    deliveryZones: {
      query: DELIVERY_ZONES,
      update (data) {
        return data.allDeliveryZones.nodes
      }
    },
    allDop: {
      query: SEARCH_ADD_PRODS_QUERY,
      update (data) {
        let map = new Map()
        let cats = data.searchDopCat.nodes
        cats.forEach(el => {
          let extraFor = JSON.parse(el.extraFor)
          if (extraFor) {
            extraFor.forEach(item => {
              let cur = map.get(item)
              if (cur) {
                map.set(item, cur.concat(el.prods.nodes))
              } else {
                map.set(item, el.prods.nodes)
              }
            })
          }
        })
        this.commit(callCenterMUT.SET_MAP_ADDITIONAL_PRODUCTS, map)
        return map
      }
    },
    branchOptions: {
      query: REST_POINT_QUERY,
      update (data) {
        let restPoints = data.allRestPoints.nodes
        this.selectPoints = restPoints.map(el => {
          return {
            id: el.id,
            value: el,
            text: el.address
          }
        })
        return restPoints
      }
    },
    allProds: {
      query: ALL_PRODUCTS_QUERY,
      update (data) {
        let prods = data.allProducts.nodes
        let prodsBrandOriginMap = new Map()
        let prodsMap = new Map()
        prods.forEach(el => {
          prodsMap.set(el.id, el)
          prodsBrandOriginMap.set(el.idBrand + '|' + el.idOrigin, el)
        })
        this.commit(callCenterMUT.SET_BRAND_ORIGIN_PRODS_MAP, prodsBrandOriginMap)
        this.commit(callCenterMUT.SET_MAP_PRODUCTS, prodsMap)
        return prods
      }
    },
    statusOptions: {
      query: STATUS_QUERY,
      update (data) {
        let stages = data.allStageOrders.nodes
        this.selectStatuses = stages.map(el => {
          return {
            id: el.id,
            value: el,
            text: el.name
          }
        })
        return stages
      }
    },
    paymentOptions: {
      query: TYPE_PAYMENT_QUERY,
      update (data) {
        let types = data.activeTypesPayment.nodes
        this.selectTypePayment = types.map(el => {
          return {
            id: el.id,
            value: el,
            text: el.name,
            disabled: el.keyword === 'card_online'
          }
        })
        return types
      }
    },
    workshopsOptions: {
      query: TYPE_WORKSHOPS,
      update: (data) => data.allTypeWorkshops.nodes
    },
    stageWorkshopsOptions: {
      query: TYPE_STAGE_WORKSHOPS,
      update: (data) => data.allStageWorkshops.nodes
    },
    brandsOptions: {
      query: ACTIVE_BRANDS_QUERY,
      update (data) {
        let brands = data.allBrands.nodes
        brands.forEach((el, index) => {
          this.pointsIndex.set(el.id, index)
        })
        this.selectBrands = brands.map(el => {
          let copyBranch = this.copyObj(el)
          delete copyBranch.cats
          return {
            value: copyBranch,
            text: copyBranch.name
          }
        })
        return brands
      }
    },
    deliveryOptions: {
      query: TYPE_DELIVERY_QUERY,
      update: (data) => data.allTypeDeliveries.nodes
    },
    latestOrdersCount: {
      query: queries.LATEST_ORDERS_COUNT,
      fetchPolicy: 'network-only',
      skip () {
        return !this.ordersWindowVisibility
      },
      variables () {
        return {
          preorders: this.showPreordersToday,
          preordersWeek: this.showPreordersWeek,
          notShow: this.showDoneOrder,
          searchQuery: this.searchQuery,
          restPointId: this.filterBranch ? this.filterBranch.id : null,
          stageId: this.filterStatus ? this.filterStatus.id : null
        }
      },
      update (data) {
        if (data.latestOrdersCount !== null) {
          this.ordersCount = data.latestOrdersCount
        } else {
          this.ordersCount = 0
        }
      }
    }
  },
  methods: {
    async addStatusesToOrder (order, idx) {
      const response = await this.$apollo.query({
        query: queries.ORDER_STATUSES_BY_ID,
        fetchPolicy: 'network-only',
        variables: {
          order: order.id
        }
      })
      const statusesResp = response.data.allStatusOrders.nodes
      const statuses = statusesResp.map(({ idStageOrder, workerByIdWorker, ...anyData }) => {
        const stage = this.allStageOrdersObj[idStageOrder]
        const worker = workerByIdWorker

        return { stage, worker, ...anyData }
      })
      const orderWithStatuses = { ...order, statuses: { nodes: statuses } }
      this.orders.splice(idx, 1, orderWithStatuses)
    },
    createAddressQuery () {
      if (!this.order) {
        console.warn('createAddressQuery exeption [this.order in null]')
        return ''
      }

      let address = this.order.street

      if (this.order.house) address += `, ${this.order.house}`

      return address
    },
    onAddressHit (event) {
      const {Address} = this.addressesData[event]
      const addressObj = Address.Components.reduce((acc, {kind, name}) => ({...acc, [kind]: name}), {}) || {}
      const {house, street, locality} = addressObj

      this.order.house = ''
      this.order.street = ''
      this.order.city = ''
      this.streetError = ''

      setTimeout(() => {
        this.order.street = street || ''
        this.order.city = locality || ''
      }, 30)

      if (!street) {
        this.streetError = 'Укажите улицу'
        return
      }

      if (!house) {
        this.streetError = 'Укажите дом'
        return
      }

      this.order.house = house
    },
    onInputAddress: lodash.debounce(function (address) {
      this.streetWasChanged = true

      if (!address) address = this.createAddressQuery()
      if (!address) return

      if (this.order.city) {
        address = `${this.order.city} ${address}`
      }

      this.$log.warning("Обращение к геокодеру Яндекса #usagestats", 'o2.geocode.CRM.' + this.$userControl.jwtParsed.role);
      // @todo перейти на DaData, кэшировать частично введенные адреса не имеет смысла
      window.ymaps.geocode(address, {
        json: true,
        boundedBy: this.geocodingRectangle,
        results: 5
      }).then(response => {
        const {GeoObjectCollection = {}} = response
        const featureMember = GeoObjectCollection.featureMember
        const addressessList = featureMember

        if (!addressessList) {
          this.possibleStreets = []
          return
        }

        const getAddress = (GeoObject) => [GeoObject.description, GeoObject.name].filter(_ => _).join(', ')

        this.addressesData = addressessList.reduce((acc, {GeoObject}) => {
          return {
            ...acc,
            [getAddress(GeoObject)]: GeoObject.metaDataProperty.GeocoderMetaData
          }
        }, {})

        this.possibleStreets = addressessList.map(({GeoObject}) => getAddress(GeoObject))
      })
    }, 750),
    closeModal () {
      this.openedModalSuggest = false
      this.ymapsToggled = false
    },
    async createOrder () {
      let approvedStage = this.statusOptions.find(el => el.keyword === STATUS_ORDER.APPROVED)
      let paymentOnlyInfo
      this.order.time = this.$moment()
      paymentOnlyInfo = this.order.paymentOnlyInfo
      let idWorkerAccept = this.order.idWorkerAccept ? this.order.idWorkerAccept : this.$userControl.jwtParsed.user_id

      let preparedOrder = this.prepareOrderForMutate(Object.assign({
        idStage: approvedStage.id,
        ymapsDuration: 0,
        ymapsDistance: 0
      }, this.order, {idWorkerAccept: idWorkerAccept}))

      delete preparedOrder.id
      let prods = []
      for (let i = 0; i < this.order.prods.nodes.length; i++) {
        let newProd = this.order.prods.nodes[i]
        let preparedProd = this.prepareProdForMutate(Object.assign(newProd))
        prods.push(preparedProd)
      }
      await this.$apollo.mutate({
        mutation: commonForOrders.CREATE_ORDER_WITH_PRODUCTS,
        variables: {
          order: preparedOrder,
          products: prods
        }
      }).then(async (data) => {
        let order = data.data.createOrderWithProducts.order
        let createdOrderId = order.id
        await this.savePayment(createdOrderId, preparedOrder, paymentOnlyInfo)
        this.order.idDay = order.idDay
        this.order.status = approvedStage
        this.setOrder(null)
        if (this.lastOrder) {
          if (this.lastOrder.status.keyword === STATUS_ORDER.CANCELED) {
            await this.softDelete(this.lastOrder.id)
            this.lastOrder = null
          }
        }
      }).catch((error) => {
        console.log('create', error)
        this.handleErrors(error, true, true)
      }).finally(() => {
        this.orderInProcessOfSaving = false
      })
    },
    async updateOrder () {
      let approvedStage = this.statusOptions.find(el => el.keyword === STATUS_ORDER.APPROVED)
      let paymentOnlyInfo
      let addInfo = {}
      if (this.order.status.keyword === STATUS_ORDER.NEW) {
        addInfo['idStage'] = approvedStage.id
      }
      paymentOnlyInfo = this.order.paymentOnlyInfo

      let preparedOrder = this.prepareOrderForMutate(Object.assign({}, this.order, addInfo))
      let orderId = preparedOrder.id

      let prods = []
      for (let i = 0; i < this.order.prods.nodes.length; i++) {
        let newProd = this.order.prods.nodes[i]
        let preparedProd = this.prepareProdForMutate(Object.assign(newProd))
        prods.push(preparedProd)
      }
      this.$apollo.mutate({
        mutation: commonForOrders.UPDATE_ORDER_WITH_PRODUCTS,
        variables: {
          order: preparedOrder,
          products: prods
        }
      }).then(async (data) => {
        await this.savePayment(orderId, preparedOrder, paymentOnlyInfo)
        this.setOrder(null)
      }).catch((error) => {
        console.log('update', error)
        this.handleErrors(error, true, true)
      }).finally(() => {
        this.orderInProcessOfSaving = false
      })
    },
    toggleCategory (catId) {
      if (this.catId === catId) {
        this.catId = null
      } else {
        this.catId = catId
      }
    },
    shownHideOrder (order) {
      let ordIndex = this.orders.findIndex(ord => ord.id === order.orderId)
      this.orders[ordIndex] = Object.assign(this.orders[ordIndex], { seen: order.seen })
    },
    withPopper (dropdownList, component, { width }) {
      /**
       * We need to explicitly define the dropdown width since
       * it is usually inherited from the parent with CSS.
       */
      dropdownList.style.width = width

      /**
       * Here we position the dropdownList relative to the $refs.toggle Element.
       *
       * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
       * the dropdownList overlap by 1 pixel.
       *
       * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
       * wrapper so that we can set some styles for when the dropdown is placed
       * above.
       */
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -1]
            }
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn ({ state }) {
              component.$el.classList.toggle(
                'drop-up',
                state.placement === 'top'
              )
            }
          }
        ]
      })

      /**
       * To prevent memory leaks Popper needs to be destroyed.
       * If you return function, it will be called just before dropdown is removed from DOM.
       */
      return () => popper.destroy()
    },
    getRealOrderPrice () {
      let price = this.orderPrice
      let discount = this.discountValue
      let deliv = 0
      if (this.order) {
        deliv = this.order.clientPriceDelivery ? parseInt(this.order.clientPriceDelivery) : 0
      }
      price = Math.max(price - discount + deliv, 0)
      return price
    },
    showOrHideOrdersWindow (val) {
      this.ordersWindowVisibility = val
    },
    showAllOrders () {
      this.numOrders = null
      this.fetchOrders(null, false, true)
      this.dispatch(callCenterACT.GET_CONFIG_ORDERS_COUNT)
    },
    checkSearchStr: lodash.debounce(function (str) {
      this.filterOrders = str
      this.searchQuery = this.filterOrders
      this.searchQuery = this.filterOrders.replace(/^\+7/ig, '8').replace(/[^a-zA-Zа-яА-Я0-9_]+/ig, '').replace(/(( ){2,})/ig, '')
      this.reloadOrders()
    }, 1000),
    restPointUpdated (newVal) {
      this.filterBranch = newVal
      this.reloadOrders()
    },
    statusUpdated (newVal) {
      this.filterStatus = newVal
      this.reloadOrders()
    },
    selectPromocode (item) {
      if (item.onlyMobile && !this.order.byMobile) {
        let errorMessage = 'Промокод можно использовать только в мобильном приложении'
        Vue.notify({
          group: 'callCenterInfo',
          type: 'warn',
          title: `Ошибка`,
          text: `${errorMessage}`
        })
        this.orderPromocode = null
      }
    },
    handleErrors (error, showInConsole = false, force = false) {
      let errorMessage = 'Произошла неизвестная ошибка'
      if (error.message !== 'undefined') {
        if (error.message.indexOf('CLIENTS_POINTS_LESS_THAN_WRITE_OFF') > -1) { errorMessage = 'У клиента недостаточно баллов на счету' }
      }
      if (showInConsole === true) {
        console.log(error)
      }
      if (force === true) {
        Vue.notify({
          group: 'callCenterInfo',
          type: 'warn',
          title: `Ошибка`,
          text: `${errorMessage}`
        })
      }
    },
    onOrdersScroll () {
      let ps = this.$refs.scrollbar.ps
      if (ps.reach.y === 'end' && this.loadingOrders === false) {
        this.getNextOrders()
      }
    },
    remindWhenNewOrder () {
      if (this.addedNewOrder) {
        try {
          let audio = new Audio(require('../sounds/notification.wav')) // path to file
          audio.play()
        } finally {
          this.addedNewOrder = false
        }
      }
    },
    addPointToOrder (order) {
      if (order.idRestPoint !== null) {
        const point = this.branchRestPointsObj[order.idRestPoint]
        return {...order, point}
      }

      return order
    },
    addStatusToOrder (order) {
      if (order.idStage !== null) {
        const status = this.allStageOrdersObj[order.idStage]
        return {...order, status}
      }

      return order
    },
    addDeliveryTypeToOrder (order) {
      if (order.idTypeDelivery !== null) {
        const typeDelivery = this.deliveryOptionsObj[order.idTypeDelivery]
        return {...order, typeDelivery}
      }

      return order
    },
    adTypePaymentToOrder (order) {
      if (order.idTypePayment !== null) {
        const typePayment = this.paymentOptionsObj[order.idTypePayment]
        return {...order, typePayment}
      }

      return order
    },
    adWorkshopsToOrder (order) {
      if (order.workshop.nodes) {
        const workshops = order.workshop.nodes.map(({ id, idTypeWorkshop, stageWorkshop }) => {
          const workshop = this.workshopsOptionsObj[idTypeWorkshop]
          const stageKey = orderFunc.createStageKey({
            idType: idTypeWorkshop,
            keyword: stageWorkshop
          })
          const currentStage = this.stageWorkshopsOptionsObj[stageKey]

          return { id, stage: { ...currentStage, workshop } }
        })

        return {...order, workshop: { nodes: workshops }}
      }

      return order
    },
    modifyOrder (order) {
      let modifiedOrder = {...order}
      modifiedOrder = this.addPointToOrder(modifiedOrder)
      modifiedOrder = this.addStatusToOrder(modifiedOrder)
      modifiedOrder = this.addDeliveryTypeToOrder(modifiedOrder)
      modifiedOrder = this.adTypePaymentToOrder(modifiedOrder)
      modifiedOrder = this.adWorkshopsToOrder(modifiedOrder)

      return modifiedOrder
    },
    modifyOrders (orders) {
      return orders.map(this.modifyOrder)
    },
    fetchOrders (fromOrderId = null, newOne = false, replace = false) {
      if (!this.loadingOrders && !this.loadingNewOrders) {
        if (newOne === true) {
          this.loadingNewOrders = true
        } else this.loadingOrders = true
        if (replace) {
          this.reloadingOrders = true
        }
        this.$apollo.query({
          query: queries.LATEST_ORDERS_FROM_LAST_ORDER,
          fetchPolicy: 'network-only',
          variables: {
            preorders: this.showPreordersToday,
            preordersWeek: this.showPreordersWeek,
            notShow: this.showDoneOrder,
            num: this.numOrders,
            lastId: fromOrderId,
            new: newOne,
            searchQuery: this.searchQuery,
            restPointId: this.filterBranch ? this.filterBranch.id : null,
            stageId: this.filterStatus ? this.filterStatus.id : null
          }
        }).then((res) => {
          if (replace === true) {
            this.orders.splice(0, this.orders.length)
          }
          if (res.data.latestOrdersFromLastOrder && res.data.latestOrdersFromLastOrder.nodes.length > 0) {
            let orders = res.data.latestOrdersFromLastOrder.nodes
            const modifiedOrders = this.modifyOrders(orders)
            this.orders = this.joinOrders(this.orders, modifiedOrders, newOne)

            if (newOne) {
              this.ordersCount += orders.length
              setTimeout(() => {
                this.remindWhenNewOrder()
              }, 100)
            }
          }
        }).finally(() => {
          this.reloadingOrders = false
          this.loadingNewOrders = false
          this.loadingOrders = false
        })
      }
    },
    async fetchProducts (id) {
      return this.$apollo.query({
        query: queries.PRODUCTS_OF_ORDER,
        fetchPolicy: 'network-only',
        variables: {
          id: id
        }
      })
    },
    getNextOrders () {
      if (this.ordersCount !== this.orders.length && !this.loadingOrders) {
        let lastOrdersId = this.orders[this.orders.length - 1].id
        this.fetchOrders(lastOrdersId)
      }
    },
    checkNewOrders () {
      let latestId = null
      if (this.orders.length > 0) {
        latestId = this.orders[0].id
      }
      if (!this.loadingNewOrders && !this.loadingOrders) {
        this.fetchOrders(latestId, true)
      }
    },
    checkExistingOrders () {
      let shownOrders = this.orders.filter(ord => ord.seen === true).map(ord => ord.id)

      if (shownOrders.length) {
        this.$apollo.query({
          query: queries.ORDERS_BATCH_GET,
          fetchPolicy: 'network-only',
          variables: {
            orderIds: shownOrders
          }
        }).then((res) => {
          if (res.data.ordersBatchGet.nodes) {
            res.data.ordersBatchGet.nodes.forEach(ord => {
              const indexOfOrder = this.orders.findIndex(item => item.id === ord.id)
              const order = this.orders[indexOfOrder]
              if (order) {
                const statusChanged = order.idStage !== ord.idStage
                if (this.filterStatus && statusChanged && this.filterStatus.id !== ord.idStage) {
                  this.orders.splice(indexOfOrder, 1)
                } else {
                  let res = Object.assign(ord, { seen: true })
                  let newOrder = this.modifyOrder(res)
                  newOrder = { ...order, ...newOrder }
                  this.orders.splice(indexOfOrder, 1, newOrder)
                }
              }
            })
          }

          return true
        })
      }
    },
    joinOrders (orders, joiningOrders, start = false) {
      for (let i = 0; i < joiningOrders.length; i++) {
        let orderIndex = orders.findIndex((order) => order.id === joiningOrders[i].id)
        if (orderIndex === -1) {
          if (start === true) {
            this.addedNewOrder = true
            orders.unshift(joiningOrders[i])
          } else {
            orders.push(joiningOrders[i])
          }
        }
      }
      return orders.sort((a, b) => (a.id < b.id) ? 1 : -1)
    },
    getter (getter) {
      return this.$store.getters[`${this.vuexNamespace}/${getter}`]
    },
    dispatch (action, payload) {
      this.$store.dispatch(`${this.vuexNamespace}/${action}`, payload)
    },
    stateVar (variable) {
      return this.$store.state.callCenter[variable]
    },
    commit (query, payload) {
      this.$store.commit(`${this.vuexNamespace}/${query}`, payload)
    },
    debounceHouseGeocode: lodash.debounce(function () {
      this.makeGeocodePosition()
    }, 1000),
    markPolygonOnMapModal (coords, force) {
      if (!coords) {
        return
      }
      let polygonModal = null
      if (this.openedModalSuggest || force) {
        polygonModal = this.zonesModal.searchContaining(coords).get(0)
      }
      for (let i = 0; i < this.zonesModal.getLength(); i++) {
        let pol = this.zonesModal.get(i)
        pol.options.set('fillColor', '#00000070')
      }
      if (polygonModal) {
        this.activePol.color = polygonModal.options.get('fillColor')
        this.activePol.pol = polygonModal
        polygonModal.options.set('fillColor', '#FFFFFF70')
      }
    },
    backgroundMap (map) {
      this.$apollo.query({
        query: DELIVERY_ZONES
      }).then((res) => {
        let delZones = res.data.allDeliveryZones.nodes
        let pols = {
          type: 'FeatureCollection',
          features: []
        }
        delZones.forEach(zone => {
          let pol = JSON.parse(zone.polygon)
          pols.features.push({
            type: 'Feature',
            id: zone.id,
            geometry: {
              type: 'Polygon',
              coordinates: [pol]
            },
            options: {strokeColor: '#000000', fillColor: '#00000070'},
            properties: {
              price: zone.clientPrice,
              priceDel: zone.deliveryPrice,
              restPoint: zone.idRestPoint,
              restPointCoords: zone.restPoint.cords,
              idZone: zone.id
            }
          })
        })
        this.zones = window.ymaps.geoQuery(pols).addToMap(map)
        this.zonesModal = window.ymaps.geoQuery(pols)
      }).catch((error) => {
        this.handleErrors(error, true)
      })
    },
    makeGeocodePosition () {
      this.coords = null
      let newValue = this.selectedPosition
      if (newValue) {
        this.order.selectedPosition = JSON.stringify(newValue)

        let address = `${newValue.sourceValue}, ${this.order.house}`
        // До перехода на DaData или т.п. кэширование будет работать очень плохо,
        // попытаемся привести адрес к единому формату для увеличения вероятности попадания.
        const addrArr = address.split(', ')
        if (addrArr.length === 4 && addrArr[0] === 'Тюмень') {
          // скорее всего это СНТ или т.п.
          addrArr.shift()
        }
        if (addrArr.length === 3) {
          // предположительно это и будет Город/улица/дом
          address = addrArr[0] + ', ' + addrArr[1] + ' ' + addrArr[2]
        }

        this.order.coords = null
        this.order.precision = null
        this.order.point = null
        this.order.settlement = null
        this.order.priceDelivery = null
        this.order.clientPriceDelivery = null
        this.order.idZone = null

        this.yandexError = false
        if (this.activePol.pol !== null) {
          this.activePol.pol.options.set('fillColor', this.activePol.color)
        }

        this.$apollo.mutate({
          mutation: SH_FIND_TARGET_RESTOURANT,
          variables: {
            address: address
          }
        }).then((str) => {
          const res = JSON.parse(str.data.shFindTargetRestourant.string)
          if (res.zone !== null) {
            // If zone was founded
            const coords = [res.coordinates.lat, res.coordinates.lon]
            this.coords = coords
            this.deliveryPoint.geometry.setCoordinates(coords)
            this.markPolygonOnMapModal(coords)

            this.order.coords = JSON.stringify(coords)
            this.order.precision = res.precision
            this.order.priceDelivery = res.zone.delivery_price
            this.order.clientPriceDelivery = res.zone.client_price
            this.order.idZone = res.zone.id_delivery_zone

            let pointId = res.rest.id_rest_point
            let point = this.branchOptions.find(point => {
              return point.id === pointId
            })
            this.order.point = point

            this.ymapsOrderCoords = coords
            this.ymapsRestPointCoords = res.rest.location.map(x => Number(x))
          }

          if (newValue.settlement === null) {
            this.order.settlement = newValue.city !== null ? 'город ' + newValue.city : null
          } else {
            this.order.settlement = newValue.settlement !== null ? newValue.settlement : null
          }
        }).catch(() => {
          // @todo Error: GraphQL error: script exited with status 65 - точка доставки не определена
          this.yandexError = true
        })
      }
    },
    cleanSuggestedValues () {
      this.suggestError = false
      this.variantsPositions = []
      this.selectedPosition = null
      this.coords = null
      if (this.order) {
        this.order.idZone = null
      }
    },
    parseYandexSuggestObj (suggestObj) {
      let resObj = {
        sourceValue: null,
        country: null,
        city: null,
        region: null,
        district: null,
        settlement: null,
        street: null,
        house: null
      }
      let valueString = suggestObj.value.trim()
      resObj.sourceValue = valueString
      let streetIndex = null
      let isCity = true
      let valueArr = valueString.split(', ')
      resObj.country = valueArr[0]
      // город или область

      let isStreetCheck = candidate => {
        return candidate && (candidate.indexOf('улица') !== -1 || candidate.indexOf('бульвар') !== -1 || candidate.indexOf('шоссе') !== -1 ||
          candidate.indexOf('проезд') !== -1 ||
          candidate.indexOf('тракт') !== -1
        )
      }

      // Фикс "Национальный парк"
      if (valueArr.length > 1) {
        if (valueArr[1].indexOf('область') !== -1) {
          isCity = false
          resObj.region = valueArr[1]
          let thirdValue = valueArr[3]
          if (
            isStreetCheck(thirdValue)
          ) {
            resObj.settlement = valueArr[2]
          } else {
            resObj.district = valueArr[2]
            resObj.settlement = valueArr[3]
          }
        } else {
          resObj.city = valueArr[0]
        }

        if (valueArr.length >= 2) {
          let lastValue = valueArr[valueArr.length - 1]
          let prevValue = valueArr[valueArr.length - 2]

          if (valueArr.length > 3) {
            const city = valueArr[valueArr.length - 3]
            resObj.city = city
            resObj.region = valueArr[0]
          }

          if (
            isStreetCheck(lastValue)
          ) {
            resObj.street = lastValue
            streetIndex = valueArr.length - 1
          } else if (
            isStreetCheck(prevValue)
          ) {
            resObj.street = prevValue
            resObj.house = lastValue
            streetIndex = valueArr.length - 2
          }
          if (isCity && streetIndex === 3) {
            resObj.settlement = valueArr[2]
          }
        }
      }
      return resObj
    },
    repeatFromHistory (order) {
      let copyOrder = this.copyObj(order)
      delete copyOrder.iikoId
      delete copyOrder.shift
      delete copyOrder.idDelivery
      delete copyOrder.paymentChanged
      if (copyOrder.typePayment.keyword === TYPE_PAYMENT.CARD_ONLINE) {
        copyOrder.typePayment = this.selectTypePayment.find(el => el.value.keyword === TYPE_PAYMENT.CASH).value
      }
      copyOrder.prods.nodes = copyOrder.prods.nodes.filter(it => it.pricePoints === 0 && !it.promocode_item)
      this.changeOrderRep(copyOrder)
    },
    changedPositionSize (item) {
      let position = this.orderProds[item.index - 1]
      if (item.prod.burger) {
        if (item.smallSize) {
          position.cost = parseInt(position.cost) + 20
        } else {
          position.cost = parseInt(position.cost) - 20
        }
      }
    },
    warningModalResult (result) {
      this.$store.dispatch(`${this.vuexNamespace}/${callCenterACT.RESULT_WARNING_MODAL}`, result)
    },
    setTypeDiscount (discount, force = false) {
      this.$store.dispatch(
        `${this.vuexNamespace}/${callCenterACT.SET_ORDER_DISCOUNT}`,
        {typeDiscount: discount, force: force}
      )
      this.randomDiscountTypeUpdate = Math.floor(Math.random() * 1000)
    },
    openModalProducts (product) {
      this.setProductInEditing(product)
      this.switchModalAdditionalProducts(true)
    },
    setProductInEditing (product) {
      this.$store.commit(`${this.vuexNamespace}/${callCenterMUT.SET_PRODUCT_IN_EDITING}`, product)
    },
    switchModalAdditionalProducts (newState) {
      this.$store.commit(`${this.vuexNamespace}/${callCenterMUT.SWITCH_MODAL_ADDITIONAL_PRODUCT}`, newState)
    },
    secondsFromNow (time) {
      return this.$moment().diff(this.$moment(time), 'seconds')
    },
    changeClient (client) {
      // this.order.client = Object.assign({}, client)
      this.$set(this.order, 'client', client)
    },
    disableConfirmByPayment (event) {
      this.disableConfirmPayment = event
    },
    updatePaymentOnlyInfo (newPaymentInfo) {
      this.order.paymentOnlyInfo = newPaymentInfo
    },
    updateTypePaymentCombined () {
      let typeCombined = this.selectTypePayment.find(el => el.value.keyword === TYPE_PAYMENT.COMBO).value
      this.order.typePayment = typeCombined
    },
    editOrder () {
      let needComment = false
      this.orderProds.forEach(product => {
        needComment |= product.deleted
      })
      if (needComment) {
        this.$refs.orderDeleteProduct.show()
      } else {
        this.saveOrder()
      }
    },
    importantOrder (order) {
      this.$apollo.mutate({
        mutation: UPDATE_ORDER_MUTATE,
        variables: {
          id: order.id,
          orderPatch: {priority: 1}
        }
      }).then((data) => {
        this.updateOrderInList(Object.assign(order, {priority: 1}))
      }).catch((error) => {
        this.handleErrors(error, true)
      })
    },
    permitMovePoint (evnt) {
      evnt.preventDefault()
      this.deliveryPoint.geometry.setCoordinates([57.137170, 65.546001])
      this.deliveryPoint.options.set('draggable', true)
      this.permitDragPoint = true
    },
    findPlace () {
      this.openedModalSuggest = true
      this.loadingGeocodePlace = true
      const orderAddress = `${this.order.city || ''} ${this.order.street} ${this.order.house || ''}`.trim()

      if (this.streetWasChanged === true || this.suggestError === false) {
        this.cleanSuggestedValues()
        this.loadingSuggest = true

        this.$log.warning('Обращение к геосаджесту Яндекса #usagestats', 'o2.geosuggest.CRM.' + this.$userControl.jwtParsed.role);
        window.ymaps.suggest(orderAddress, {boundedBy: this.geocodingRectangle, results: 20}).then(res => {
          this.loadingSuggest = false
          let objsSuggest = res.map(it => this.parseYandexSuggestObj(it))
          let objsSuggestFull = []
          objsSuggest.forEach(it => {
            let mustAdded = ((it.city.includes('Тюмен') || it.region.includes('Тюмен')) &&
              it.street)
            if (mustAdded) {
              let indexOfObj = objsSuggestFull.findIndex(obj => {
                return obj.country === it.country &&
                  obj.city === it.city &&
                  obj.settlement === it.settlement &&
                  obj.street === it.street
              })
              if (indexOfObj === -1) {
                if (it.house) {
                  it.house = null
                  it.sourceValue = it.sourceValue.substr(0, it.sourceValue.lastIndexOf(','))
                }
                objsSuggestFull.push(it)
              }
            }
          })
          objsSuggest = objsSuggestFull
          this.variantsPositions = objsSuggest
        }).catch(error => {
          console.error('window.ymaps1 catch', error)
          this.handleErrors(error, true)
          this.yandexError = true
          this.suggestError = true
          this.loadingSuggest = false
        })
        this.streetWasChanged = false
      }
    },
    determineZoneDelivery (coords) {
      this.order.coords = JSON.stringify(coords)
      let containing = this.zones.searchContaining(coords)

      let polygon = containing.get(0)
      this.order.priceDelivery = null
      this.order.clientPriceDelivery = null
      this.order.point = null
      this.order.idZone = null
      if (this.activePol.pol !== null) {
        this.activePol.pol.options.set('fillColor', this.activePol.color)
      }
      // If zone was founded
      this.markPolygonOnMapModal(coords)
      if (polygon) {
        this.order.clientPriceDelivery = polygon.properties.get('price')
        this.order.priceDelivery = polygon.properties.get('priceDel')

        let pointId = polygon.properties.get('restPoint')
        this.ymapsOrderCoords = coords
        this.ymapsRestPointCoords = JSON.parse(polygon.properties.get('restPointCoords')).map(x => Number(x))
        let point = this.branchOptions.find(point => {
          return point.id === pointId
        })

        this.order.point = point
        this.order.idZone = polygon.properties.get('idZone')
      } else {
        this.order.clientPriceDelivery = null
        this.order.priceDelivery = null
      }
    },
    async createRouteMatrixAndDetermineDistance () {
      if (this.ymapsRestPointCoords && this.ymapsOrderCoords) {
        let restPointCoords = this.ymapsRestPointCoords
        let orderCoords = this.ymapsOrderCoords

        var control = this.ymap.controls.get('routePanelControl')

        control.routePanel.state.set({
          type: 'auto',
          from: restPointCoords,
          to: orderCoords

        })

        control.routePanel.options.set({
          allowSwitch: false,
          reverseGeocoding: true,
          types: {
            taxi: true // masstransit: true, pedestrian: true,
          }
        })
        let vm = this
        control.routePanel.getRouteAsync().then(function (route) {
          route.model.setParams({results: 1}, true)
          route.model.events.add('requestsuccess', function (e) {
            let activeRoute = route.getActiveRoute()
            if (activeRoute) {
              let duration = route.getActiveRoute().properties.get('duration')
              let distance = route.getActiveRoute().properties.get('distance')
              let messageToCallOperators = `<span>Расстояние до клиента: <span style="font-weight: bold; font-style: italic">${distance.text}</span>
              , время в пути: <span style="font-weight: bold; font-style: italic">${duration.text}</span></span>`
              let balloonContentLayout = window.ymaps.templateLayoutFactory.createClass(messageToCallOperators)
              route.options.set('routeBalloonContentLayout', balloonContentLayout)
              Vue.notify({
                group: 'callCenterInfo',
                type: 'success',
                title: `Расстояние до клиента`,
                text: `${messageToCallOperators}`,
                duration: 10000
              })
              vm.ymapsMatrixCreated = true
              if (duration && distance) {
                vm.order.ymapsDuration = Math.round(duration.value)
                vm.order.ymapsDistance = Math.round(distance.value)
              }
            }
          })
        })
        this.ymapsCoords.dynamic = orderCoords
      }
    },
    mapInitHandler (map) {
      this.ymap = map
      this.deliveryPoint = new window.ymaps.GeoObject({
        geometry: {
          type: 'Point',
          coordinates: this.coords ? this.coords : [57.137170, 65.546001]
        }
      }, {
        preset: 'islands#blackDotIconWithCaption',
        iconCaptionMaxWidth: '215'
      })

      let pols = {
        type: 'FeatureCollection',
        features: []
      }

      this.deliveryPoint.events.add('dragend', () => {
        let coords = this.deliveryPoint.geometry.getCoordinates()
        this.determineZoneDelivery(coords)
      })

      map.geoObjects.add(this.deliveryPoint)

      this.zonesModal.addToMap(map)
      this.markPolygonOnMapModal(JSON.parse(this.order.coords), true)
    },
    mapInitHandler1 (map) {
      this.ymap1 = map
    },
    copyObj (obj) {
      return JSON.parse(JSON.stringify(obj))
    },
    addProd (prod) {
      if (!this.readonly) {
        if (prod.motivateSum > 0) {
          if (this.clearProductsSum >= this.getter(callCenterGetters.MOTIVATED_MIN_REQUIRED_SUM_OF_PRODUCTS)) {
            this.$store.commit(`${this.vuexNamespace}/${callCenterMUT.ADD_PRODUCT_TO_ORDER}`, prod)
          } else {
            Vue.notify({
              group: 'callCenterInfo',
              type: 'warn',
              title: `Ошибка`,
              text: 'Невозможно добавить акционные товары. Необходимо добавить товары на сумму не менее 500 рублей.'
            })
          }
        } else {
          if (!this.order) {
            this.changeOrder(this.copyObj(this.emptyOrder))
          }
          this.$store.commit(`${this.vuexNamespace}/${callCenterMUT.ADD_PRODUCT_TO_ORDER}`, prod)
        }
      }
    },
    stringAddress: orderFunc.stringAddress,
    updateIndexProds () {
      let num = 1
      if (this.orderProds != null) {
        this.orderProds.forEach((prod) => {
          prod.index = num++
        })
      }
    },
    /**
     * Edit count of product
     * @param prod Object - product order
     * @param diff Number - diff between prev and new value
     * */
    changeProdCount (prod, diff) {
      prod.count = prod.count + diff
      this.changedProdCount(prod)
    },
    /**
     * Event after edit count of products in order
     * @param prod Object - product order
     * */
    changedProdCount (prod) {
      if (prod.count === 0) {
        this.delProd(prod.index)
      }
    },
    delProd (index) {
      if (!this.readonly) {
        this.orderProds.splice(index - 1, 1)
      } else {
        let prod = this.orderProds[index - 1]
        prod.deleted = !prod.deleted
        if (prod._rowVariant) {
          delete prod._rowVariant
        } else {
          prod._rowVariant = 'danger'
        }
        this.orderProds.splice(index - 1, 1, Object.assign({}, prod))
      }
    },
    prepareOrder () {
      this.order.price = this.getRealOrderPrice().toString()
      this.order.pricePoints = this.orderPricePoints.toString()
      if (!this.order.prods) {
        this.order.prods = {}
      }
      this.order.prods.nodes = this.copyObj(this.orderProds)
      this.order.prods.nodes.forEach(el => delete el.index)
      let oldOrd = this.orders.find(el => el.id === this.order.id)

      if (!oldOrd) {
        oldOrd = this.copyObj(this.emptyOrder)
      }

      if (this.order && this.order.id) {
        //  existing order
        let oldOrderFromList = this.orders.find((el) => el.id === this.order.id)
        if (oldOrderFromList && oldOrderFromList.prods) {
          oldOrd.prods.nodes = this.copyObj(oldOrderFromList.prods.nodes)
          oldOrd.prods.nodes.forEach(copyProd => {
            copyProd.groupProds = []
            if (copyProd.group !== null && copyProd.group.length !== 0) {
              let subProds = copyProd.group.split('|').map(item => parseInt(item))
              let mainProd = this.prodsMap.get(copyProd.idProduct)
              copyProd.mainProd = mainProd
              copyProd.name = mainProd.name
              subProds.forEach((prodId, ind) => {
                copyProd.groupProds.push(this.prodsMap.get(prodId))
              })
            }
          })
        }
      } else {
        oldOrd.prods.nodes = []
      }

      this.oldOrder = oldOrd
    },
    prepareOrderForMutate (order) {
      let preparedOrder = this.copyObj(order)
      let promocodeResult = this.getter(callCenterGetters.PROMOCODE_RESULT_TYPE)
      if (promocodeResult === 'discount_percent') {
        preparedOrder.discountValue = this.getter(callCenterGetters.SUM_ORDER_DISCOUNT)
      } else {
        preparedOrder.discountValue = parseInt(preparedOrder.discountValue)
      }

      preparedOrder.idWorkerAccept = preparedOrder.idWorkerAccept ? preparedOrder.idWorkerAccept : this.$userControl.jwtParsed.user_id
      delete preparedOrder.idWorkerOpened
      preparedOrder.sum = preparedOrder.price
      preparedOrder.sumPoints = preparedOrder.pricePoints
      preparedOrder.idTypePayment = preparedOrder.typePayment.id
      preparedOrder.idRestPoint = preparedOrder.point.id
      preparedOrder.idTypeDelivery = preparedOrder.typeDelivery.id
      preparedOrder.idTypeDiscount = preparedOrder.discountType.id

      if (preparedOrder.client) {
        preparedOrder.idClient = preparedOrder.client.id
      }

      if (preparedOrder.brand) {
        preparedOrder.idBrand = preparedOrder.brand.id
        delete preparedOrder.brand
      } else {
        preparedOrder.idBrand = this.orderProds[0].idBrand
      }
      if (preparedOrder.promocode) {
        preparedOrder.idPromocode = preparedOrder.promocode.id
        preparedOrder.promocode = preparedOrder.promocode.promocode
      }

      delete preparedOrder.client
      delete preparedOrder.seen
      delete preparedOrder.deleted
      delete preparedOrder.price
      delete preparedOrder.statuses
      delete preparedOrder.workshop
      delete preparedOrder.workerAccept
      delete preparedOrder.diff
      delete preparedOrder.idOrigin
      delete preparedOrder.payment
      delete preparedOrder.pricePoints
      delete preparedOrder.prods
      delete preparedOrder.courier
      delete preparedOrder.paymentOnlyInfo
      delete preparedOrder.timeOpened
      delete preparedOrder.idDay
      delete preparedOrder.priority
      delete preparedOrder.mustAutoconfirm
      delete preparedOrder.timesPrinted
      delete preparedOrder.typePayment
      delete preparedOrder.typeDelivery
      delete preparedOrder.point
      delete preparedOrder.discountType
      delete preparedOrder.status
      delete preparedOrder.__typename
      delete preparedOrder.prods

      if (this.courierAutoAssignStatus === false) {
        preparedOrder.ymapsDuration = null
        preparedOrder.ymapsDistance = null
      }
      return preparedOrder
    },
    prepareProdForMutate (prod) {
      let preparedProd = this.copyObj(prod)
      preparedProd.pricePoints = preparedProd.pricePoints ? preparedProd.pricePoints : 0
      preparedProd.price = preparedProd.cost
      delete preparedProd.cost
      delete preparedProd.existNew
      delete preparedProd.category
      delete preparedProd._rowVariant
      delete preparedProd.__typename
      delete preparedProd.maxDiscount
      delete preparedProd.isSale
      delete preparedProd.description
      delete preparedProd.idOriginCat
      delete preparedProd.idCategory
      delete preparedProd.motivateSum

      let nameParts = []
      nameParts.push(preparedProd.group ? preparedProd.mainProd.name : preparedProd.name)
      if (preparedProd.prod.burger && !preparedProd.smallSize) {
        nameParts.push('(говядина)')
      }
      if (preparedProd.smallSize) {
        if (preparedProd.prod.burger) {
          nameParts.push('(свинина)')
        } else {
          nameParts.push('(на тонком тесте)')
        }
      }
      if (preparedProd.group) {
        let newGoods = []
        preparedProd.groupProds.forEach(el => {
          newGoods.push(el.id)
          nameParts.push(el.name)
        })

        preparedProd.group = newGoods.join('|')
      }
      preparedProd.name = nameParts.join(' + ')
      delete preparedProd.prod
      if (preparedProd.group === preparedProd.idProduct.toString()) {
        preparedProd.group = null
      }
      delete preparedProd.groupProds
      delete preparedProd.mainProd
      return preparedProd
    },
    getOrder (orderId) {
      return this.$apollo.query({
        query: queries.ORDER_BY_ID,
        fetchPolicy: 'network-only',
        variables: {
          id: orderId
        }
      }).then(res => res.data.allOrders.nodes[0])
    },
    async changeOrder (order) {
      let ord = null

      if (order && order.id) {
        ord = await this.getOrder(order.id)
      } else if (order) {
        ord = order
      }

      // set default oldOrd
      this.oldOrd = null
      // Trying to change order when one of order is null or setted order id is null || (id newOrder not equal current order)
      if (!this.order || !ord || !ord.id || (this.order && ord && ord.id !== this.order.id)) {
        if (this.order && this.order.id !== null) {
          this.prepareOrder()
          let oldOrd = this.oldOrder

          if (this.order.status.keyword !== STATUS_ORDER.NEW || JSON.stringify(oldOrd) === JSON.stringify(this.order)) {
            this.setOrder(ord)
          } else {
            this.nextOrder = ord
            this.$refs.confirmOrder.show()
          }
        } else {
          this.setOrder(ord)
        }
      }
    },
    cancelOrder () {
      if (this.isRestManager) {
        return
      }
      this.repeat = false
      this.$refs.causeCancelOrder.showModalCancel()
    },
    cancelOrderRepeat () {
      if (this.isRestManager) {
        return
      }
      this.repeat = true
      this.$refs.causeCancelOrder.showModalCancel()
    },
    async orderCanceled (orderId) {
      let canceledStage = this.statusOptions.find(el => el.keyword === STATUS_ORDER.CANCELED)
      let order = this.orders.find(el => el.id === orderId)
      this.updateOrderInList(Object.assign(order, {status: canceledStage}))
      if (this.repeat === false) {
        this.changeOrder()
      } else {
        this.changeOrderRep(order, orderId)
      }
    },
    sumWithGroup (prod) {
      let dopSum = parseFloat(prod.mainProd.cost)
      prod.groupProds.forEach(dop => {
        dopSum += parseFloat(dop.cost)
      })
      prod.cost = dopSum.toFixed(2)
      return dopSum
    },
    summaryWithGroup (prod, points = false) {
      let mainProdCost = points ? prod.pricePoints : prod.cost
      return parseFloat(mainProdCost) * parseFloat(prod.count)
    },
    discByGroup (prod) {
      let disc = parseFloat(prod.mainProd.cost * prod.mainProd.maxDiscount / 100)
      prod.groupProds.forEach(dop => {
        disc += parseFloat(dop.cost * dop.maxDiscount / 100)
      })
      return disc
    },
    async setOrder (ord) {
      if (ord && ord.id && ord.status.keyword === STATUS_ORDER.NEW) {
        // enable loading indicating
        this.loadingCheckOrderIndicator = true
        let res = await this.$apollo.mutate({
          mutation: commonForOrders.TRY_OPEN_ORDER,
          variables: {
            idOrder: ord.id
          }
        }).catch(error => {
          this.handleErrors(error, true)
          this.loadingCheckOrderIndicator = false
        })
        this.loadingCheckOrderIndicator = false
        if (res) {
          let permitChooseOrder = res.data.tryOpenOrder.boolean
          if (permitChooseOrder) {

          } else {
            this.$refs.anotherOperatorActive.show()
            return
          }
        }
      }
      // создание копии объекта заказа
      this.order = this.copyObj(ord)
      this.orderProds = []
      this.permitDragPoint = false
      if (this.deliveryPoint) {
        this.deliveryPoint.options.set('draggable', false)
      }
      this.cleanSuggestedValues()
      this.streetWasChanged = true
      this.$store.dispatch(`${this.vuexNamespace}/${callCenterACT.SET_CURRENT_ORDER}`, this.order)

      // Если данные заказа содержат продукты
      if (this.order && this.order.id && !this.loadingProducts) {
        this.loadingProducts = true
        let prodsRes = await this.fetchProducts(this.order.id)
        let prods = prodsRes.data.allProductOrders

        if (prods) {
          Object.assign(this.order, {
            prods: prods
          })
        }
        this.loadingProducts = false
      }

      let newIndex = null
      if (this.order && this.order.prods) {
        this.order.prods.nodes.forEach(prod => {
          // Update index tab for correct order
          if (newIndex === null) {
            newIndex = this.pointsIndex.get(prod.category.idBrand)
            this.tabIndex = newIndex
          }
          let copyProd = this.copyObj(prod)
          if (ord.id && copyProd.deleted) {
            copyProd._rowVariant = 'danger'
          } else {
            delete copyProd._rowVariant
          }
          copyProd.groupProds = []
          if (copyProd.group !== null && copyProd.group.length !== 0) {
            let subProds = copyProd.group.split('|').map(item => parseInt(item))
            let mainProd = this.prodsMap.get(copyProd.idProduct)
            copyProd.mainProd = mainProd
            copyProd.name = mainProd.name
            subProds.forEach((prodId, ind) => {
              copyProd.groupProds.push(this.prodsMap.get(prodId))
            })
          }
          let mainProd = this.prodsMap.get(copyProd.idProduct)
          if (mainProd) {
            copyProd.mainProd = mainProd
            copyProd.name = mainProd.name
          }
          this.orderProds.push(copyProd)
        })
      }
    },
    savePayment (id, preparedOrder, paymentObj) {
      if (!paymentObj) {
        paymentObj = {}
        paymentObj[this.order.typePayment.keyword] = preparedOrder.sum
      }
      if (this.order.typePayment.keyword !== TYPE_PAYMENT.COMBO) {
        paymentObj = {}
        paymentObj[this.order.typePayment.keyword] = preparedOrder.sum
      }
      let convertedPaymentObj = {}
      for (let keywordPayment in paymentObj) {
        let camelProp = this.$lodash.camelCase(keywordPayment)
        convertedPaymentObj[camelProp] = paymentObj[keywordPayment]
      }

      return this.$apollo.mutate({
        mutation: UPDATE_COMBO_PAYMENT,
        variables: {
          idOrder: id,
          paymentPayload: convertedPaymentObj
        }
      })
    },
    async saveOrder () {
      this.orderInProcessOfSaving = true
      this.prepareOrder()

      await this.dispatch(callCenterACT.GET_COURIER_AUTO_ASSIGN_STATUS, this.order.point.id)
      let courierAutoAssign = this.getter(callCenterGetters.COURIER_AUTO_ASSIGN)

      if (courierAutoAssign === true && this.order.typeDelivery.keyword === TYPE_DELIVERY.DELIVERY) {
        let notEmpty = this.order.ymapsDistance !== null && this.order.ymapsDuration !== null
        if (notEmpty === false) {
          Vue.notify({
            group: 'callCenterInfo',
            type: 'error',
            title: 'Ошибка',
            text: 'Необходимо переопределить точку доставки и построить маршрут для данного заказа',
            duration: 5000
          })
          this.orderInProcessOfSaving = false
          return
        }
      }
      if (this.order.id !== null) {
        await this.updateOrder()
      } else {
        await this.createOrder()
      }
      this.ymapsMatrixCreated = false
    },
    updateOrderInList (order) {
      Object.assign(this.orders.find(el => el.id === this.order.id), order)
    },
    async softDelete (orderId) {
      this.$apollo.mutate({
        mutation: SOFT_DELETE_ORDER,
        variables: {
          id: orderId,
          orderPatch: {
            deleted: true
          }
        }
      })
    },
    async changeOrderRep (ord, prevOrderId = null) {
      const order = await this.getOrder(ord.id)

      if (order.status.keyword === STATUS_ORDER.CANCELED) {
        this.lastOrder = this.copyObj(order)
      }

      let repOrder = this.copyObj(order)
      let statusNew = this.statusOptions.find(el => el.keyword === STATUS_ORDER.NEW)

      repOrder.id = null
      delete repOrder.idStage

      repOrder.idCopiedOrder = prevOrderId
      repOrder.time = this.$moment()
      repOrder.forDay = this.$moment().format('YYYY-MM-DD')
      repOrder.priority = 0
      repOrder.status = statusNew

      let newProds = []
      let prodsRes = await this.fetchProducts(order.id)
      let prods = prodsRes.data.allProductOrders

      if (prods) {
        Object.assign(repOrder, {
          prods: prods
        })
      }

      repOrder.prods.nodes.forEach(prod => {
        let existProduct = this.prodsMap.get(prod.idProduct) !== null ? this.prodsMap.get(prod.idProduct) : null
        if (existProduct !== null) {
          if (prod.prod.burger === true && prod.smallSize === false) {
            let realCost = parseInt(existProduct.cost)
            let oldCost = parseInt(prod.cost)
            if (realCost === oldCost) {
              oldCost += 20
            }
            prod.cost = oldCost
          }
          let copyProd = Object.assign({}, prod)
          delete copyProd.id
          newProds.push(copyProd)
        }
      })

      repOrder.prods.nodes = newProds
      this.setOrder(repOrder)
      this.$refs.listOrders.hide()
    },
    updateBalanceUser (idOrder, sum, type = null, comment = null) {
      this.$apollo.mutate({
        mutation: commonForOrders.UPDATE_BALANCE_USER,
        variables: {
          'idOrder': idOrder,
          'sum': sum,
          'type': type,
          'comment': comment
        }
      }).then((res) => {
        // console.log(res)
      })
    },
    /**
     * Clean list of orders and refetch them
     * */
    reloadOrders () {
      this.orders.splice(0, this.orders.length)
      this.fetchOrders(null, false, true)
    },
    forceReloadOrders () {
      this.$apollo.queries.latestOrdersCount.refetch()
      this.reloadOrders()
    },
    requestClient () {
      this.$store.dispatch(`${this.vuexNamespace}/${callCenterACT.REQUEST_CLIENT}`)
    }
  },
  created () {
    this.dispatch(callCenterACT.GET_DISCOUNT_OPTIONS)
    this.dispatch(callCenterACT.CC_CONFIGS_BATCH_GET)
    this.dispatch(callCenterACT.REQUEST_PROMOCODES)
    this.dispatch(callCenterACT.GET_LAST_ID)
    this.dispatch(callCenterACT.GET_IS_REST_MANAGER)

    this.$root.$refs.OrderInfo = this

    this.intervalPromocodes = setInterval(() => {
      this.dispatch(callCenterACT.REQUEST_PROMOCODES)
    }, 1000 * 60 * 5)

    this.$store.watch(
      (state, getters) => state.callCenter.activatedPromocodeGood ? getters[`${this.vuexNamespace}/${callCenterGetters.SUM_OF_PRODUCTS}`] : null,
      (newValue) => {
        let promocodeItem = this.getter(callCenterGetters.ORDER_PROMOCODE_ITEM)
        if (newValue) {
          this.dispatch(callCenterACT.CHECK_PROMOCODE_GOOD)
        } else {
          if (promocodeItem) {
            this.$store.commit(`${this.vuexNamespace}/${callCenterMUT.DELETE_PROMOCODE_ITEM}`)
          }
        }
      }
    )

    this.$store.watch(
      (state, getters) => state.callCenter.order ? state.callCenter.order.phone : null,
      (newValue) => {
        this.requestClient()
      }
    )

    this.$store.watch(
      (state, getters) => state.callCenter.selectedBrand ? state.callCenter.selectedBrand.id : null,
      (newValue) => {
        this.requestClient()
      }
    )

    this.$store.watch(
      (state, getters) => getters[`${this.vuexNamespace}/${callCenterGetters.CLIENT_CURRENT_ORDER}`],
      (newValue) => {
        this.$store.dispatch(`${this.vuexNamespace}/${callCenterACT.CLIENT_UPDATED}`)
      }
    )
  },
  watch: {
    clearProductsSum (val) {
      if (this.orderProds && val < this.getter(callCenterGetters.MOTIVATED_MIN_REQUIRED_SUM_OF_PRODUCTS) && this.motivatedProductsCount > 0) {
        let motivatedProds = this.orderProds.filter((prod) => prod.motivateSum > 0 || prod.prod.motivateSum > 0)

        motivatedProds.forEach((prod) => {
          let motivatedProdIndex = this.orderProds.findIndex((orderProd) => orderProd.id === prod.id)
          this.orderProds.splice(motivatedProdIndex, 1)
        })
      }
    },
    ordersWindowVisibility (val) {
      if (val) {
        this.fetchOrders(null, false, true)
      } else {
        this.orders.splice(0, this.orders.length)
      }
    },
    filterOrders (newVal) {
      this.checkSearchStr(newVal)
    },
    showPreordersToday () {
      this.reloadOrders()
    },
    showPreordersWeek () {
      this.reloadOrders()
    },
    showDoneOrder () {
      this.reloadOrders()
    },
    selectedPosition (newValue) {
      this.makeGeocodePosition()
    },
    async 'order.point' (newValue, oldValue) {
      if (this.order && newValue && newValue !== oldValue) {
        await this.dispatch(callCenterACT.GET_COURIER_AUTO_ASSIGN_STATUS, this.order.point.id)
      }
    },
    'order.house' () {
      this.debounceHouseGeocode()
    },
    'orderProds' () {
      this.updateIndexProds()
    },
    tabIndex (value) {
      this.$store.commit(`${this.vuexNamespace}/${callCenterMUT.SET_TAB_INDEX_BRAND}`, value)
      this.$store.commit(`${this.vuexNamespace}/${callCenterMUT.SET_BRAND}`, this.brandsOptions[value])
    }
  },
  computed: {
    yandexSearchProvider () {
      // Не кладём в data() - иначе Vue сделает провайдер реактивным, а SearchControl
      // передаёт его же обратно в options при каждом вызове suggest/geocode, что приводит
      // к переполнению стека при попытке сериализовать options для ключа кэша.
      return yandexSearchProviderModule
    },
    branchRestPointsObj () {
      return this.branchOptions.reduce((acc, item) => ({...acc, [item.id]: item}), {})
    },
    allStageOrdersObj () {
      return this.statusOptions.reduce((acc, item) => ({...acc, [item.id]: item}), {})
    },
    deliveryOptionsObj () {
      return this.deliveryOptions.reduce((acc, item) => ({...acc, [item.id]: item}), {})
    },
    paymentOptionsObj () {
      return this.paymentOptions.reduce((acc, item) => ({...acc, [item.id]: item}), {})
    },
    workshopsOptionsObj () {
      return this.workshopsOptions.reduce((acc, item) => ({...acc, [item.id]: item}), {})
    },
    stageWorkshopsOptionsObj () {
      return this.stageWorkshopsOptions.reduce((acc, item) => ({...acc, [orderFunc.createStageKey(item)]: item}), {})
    },
    courierAutoAssignStatus () {
      return this.getter(callCenterGetters.COURIER_AUTO_ASSIGN)
    },
    checkMotivatedProductsSummaryOnSave () {
      if (this.motivatedProductsCount > 0) {
        return this.clearProductsSum >= this.getter(callCenterGetters.MOTIVATED_MIN_REQUIRED_SUM_OF_PRODUCTS)
      } else return true
    },
    ordersAreFiltered () {
      return this.filterOrders.length > 0 || this.filterStatus !== null || this.filterBranch !== null || this.showPreordersToday || this.showPreordersWeek || this.showDoneOrder
    },
    numOrders: {
      set (value) {
        this.$store.commit(`${this.vuexNamespace}/${callCenterMUT.SET_CONFIG_ORDERS_COUNT}`, value)
      },
      get () {
        return this.$store.getters[`${this.vuexNamespace}/${callCenterGetters.ORDERS_COUNT}`]
      }
    },
    prodsMap () {
      return this.stateVar(callCenterVars.mapProducts)
    },
    orderPromocode: {
      set (newVal) {
        this.$store.dispatch(`${this.vuexNamespace}/${callCenterACT.SET_ORDER_PROMOCODE}`, newVal)
        this.randomPromocodeUpdate = Math.floor(Math.random() * 1000)
      },
      get () {
        return this.$store.getters[`${this.vuexNamespace}/${callCenterGetters.SELECTED_PROMOCODE}`]
      }
    },
    promocodeOptions () {
      return this.$store.getters[`${this.vuexNamespace}/${callCenterGetters.PROMOCODES_SELECT_OPTIONS}`]
    },
    orderProds: {
      set (newVal) {
        this.$store.commit(`${this.vuexNamespace}/${callCenterMUT.SET_ORDER_PRODUCTS}`, newVal)
      },
      get () {
        return this.$store.getters[`${this.vuexNamespace}/${callCenterGetters.ORDER_PRODUCTS}`]
      }
    },
    blockDiscountChange () {
      return this.$store.state.callCenter[`${callCenterVars.blockChangeSumOfDiscount}`]
    },
    orderTypeDiscount () {
      return this.$store.getters[`${this.vuexNamespace}/${callCenterGetters.ORDER_TYPE_DISCOUNT}`]
    },
    warningModalObject () {
      return this.$store.state.callCenter[`${callCenterVars.objectWarningModal}`]
    },
    showWarningModal () {
      return this.$store.state.callCenter[`${callCenterVars.showWarningModal}`]
    },
    openedModalAdditionalProducts () {
      return this.$store.state.callCenter[`${callCenterVars.showedModalAdditionalProducts}`]
    },
    productInEditing () {
      return this.$store.state.callCenter[`${callCenterVars.productInEditing}`]
    },
    holdTime () {
      return this.$store.getters[`${this.vuexNamespace}/${callCenterGetters.ORDER_HOLD_TIME}`]
    },
    ordersOpened () {
      let opened = this.orders.filter(item => item.idWorkerOpened !== null && item.idWorkerOpened !== this.userId)
      return opened
    },
    jwtParsed () {
      return this.$store.getters['getJwtParsed']
    },
    userId () {
      return this.$store.getters['userId']
    },
    isRestManager () {
      return (true === this.$store.state.callCenter[`${callCenterVars.isRestManager}`])
    },
    selectDiscount () {
      return this.$store.getters[`${this.vuexNamespace}/${callCenterGetters.TYPE_DISCOUNT_OPTIONS_SELECT}`]
    },
    readonly () {
      return this.$store.getters[`${this.vuexNamespace}/${callCenterGetters.IS_ACCEPTED_ORDER}`]
    },
    collected () {
      return this.$store.getters[`${this.vuexNamespace}/${callCenterGetters.COLLECTED}`]
    },
    clientIdent () {
      return {
        brand: this.brandsOptions[this.tabIndex],
        clientPhone: (this.order ? (this.order.phone ? this.order.phone : '') : ''),
        clientObj: this.order ? this.order.client : null
      }
    },
    priceDel: {
      get () {
        if (!this.order || this.order.clientPriceDelivery === null) {
          return 'Стоим не определ.'
        } else {
          return this.order.clientPriceDelivery + ' руб.'
        }
      },
      set (newVal) {
        this.order.clientPriceDelivery = newVal
      }
    },
    currentDate () {
      return this.$moment().format('YYYY-MM-DD')
    },
    permitSaveOrder () {
      let permit = true
      permit &= this.orderProds.length !== 0
      permit &= this.order.typeDelivery.keyword === TYPE_DELIVERY.PICKUP || (this.order.clientPriceDelivery !== null || this.yandexError === true)
      permit &= this.order.point !== null && this.order.point !== undefined
      permit &= this.order.typePayment !== null && this.order.typePayment !== undefined
      permit &= this.order.typeDelivery !== null && this.order.typeDelivery !== undefined
      permit &= (this.order.client !== null && this.order.client !== undefined) || (this.order.phone && this.order.phone.length === 17)
      permit &= (this.order.typeDelivery && this.order.typeDelivery.keyword === TYPE_DELIVERY.PICKUP) ||
          (this.order.street && this.order.street.length > 0)
      permit &= this.orderPricePoints === 0 || this.orderPrice >= 900
      permit &= this.order.phone && this.order.phone.length === 17 && (this.order.phone[3] === '9' || this.order.phone[3] === '3')
      permit &= this.order.forDay >= this.$moment(this.order.time).subtract(5, 'hours').format('YYYY-MM-DD')
      permit &= (this.order.forDay === this.$moment().format('YYYY-MM-DD') && (this.order.forTime >= this.$moment().format('HH:mm:ss') || !this.order.forTime)) ||
          (this.order.forDay !== this.$moment().format('YYYY-MM-DD') && this.order.forTime !== null && this.order.forTime !== undefined)
      permit &= this.checkMotivatedProductsSummaryOnSave
      permit &= this.courierAutoAssignStatus === false || this.ymapsMatrixCreated === true || this.order.typeDelivery.keyword === TYPE_DELIVERY.PICKUP
      return permit
    },
    filteredClients () {
      if (this.selectedBranch !== null) {
        return this.allClients.get(this.selectedBranch.id)
      }
      return []
    },
    allowEditAddress () {
      return this.order && this.order.typeDelivery.keyword === this.constDelivery.DELIVERY
    },
    orderPrice () {
      let sum = this.orderProds.reduce((accum, prod) => {
        if (!prod.deleted) {
          if (prod.group === null || prod.group === undefined) {
            return accum + prod.cost * prod.count
          } else {
            return accum + this.sumWithGroup(prod) * prod.count
          }
        } else {
          return accum + 0
        }
      }, 0)
      return sum
    },
    clearProductsSum () {
      let sum = 0
      if (this.orderProds) {
        sum = this.orderProds.reduce((accum, prod) => {
          let motivateSum
          if (prod.prod) {
            motivateSum = prod.prod.motivateSum
          } else motivateSum = prod.motivateSum
          if (!prod.deleted && parseInt(motivateSum) === 0) {
            if (prod.group === null || prod.group === undefined) {
              return accum + prod.cost * prod.count
            } else {
              return accum + this.sumWithGroup(prod) * prod.count
            }
          } else return accum + 0
        }, 0)
      }
      return sum
    },
    motivatedProductsCount () {
      return this.orderProds ? this.orderProds.filter((prod) => prod.motivateSum > 0 || prod.prod.motivateSum > 0).length : 0
    },
    orderPricePoints () {
      return this.orderProds.reduce((accum, prod) => {
        if (!prod.deleted) {
          return accum + (prod.pricePoints ? prod.pricePoints : 0) * prod.count
        } else return accum + 0
      }, 0)
    },
    realOrderPrice () {
      let price = this.orderPrice
      let discount = this.discountValue
      let deliv = 0
      let comboPrice = 0
      if (this.order) {
        deliv = this.order.clientPriceDelivery ? parseInt(this.order.clientPriceDelivery) : 0
      }
      if (this.order.paymentOnlyInfo) {
        let payments = this.order.paymentOnlyInfo
        for (let keywordPayment in payments) {
          comboPrice += payments[keywordPayment]
        }
      }
      price = Math.max(comboPrice, price)
      return Math.max(price - discount + deliv, 0)
    },
    discountValue () {
      return this.$store.getters[`${this.vuexNamespace}/${callCenterGetters.SUM_ORDER_DISCOUNT}`]
    },
    maxDiscount () {
      return Math.ceil(this.orderProds.reduce((accum, prod) => {
        if (prod.cost > 0) {
          if (prod.group === null || prod.group === undefined) {
            if (prod.prod === null || prod.prod === undefined) {
              return accum + prod.cost * prod.maxDiscount * prod.count / 100
            } else {
              return accum + prod.cost * prod.prod.maxDiscount * prod.count / 100
            }
          } else {
            return accum + this.discByGroup(prod) * prod.count
          }
        } else {
          return accum
        }
      }, 0))
    },
    filterOrds () {
      return this.orders
    },
    filterProds () {
      let prods = []
      prods = prods.concat(this.brandsOptions[this.tabIndex].cats.nodes[this.catId].prods ? this.brandsOptions[this.tabIndex].cats.nodes[this.catId].prods.nodes : [])
      return prods.filter((prod) => {
        let check = true
        check &=
            new RegExp('.*' + this.filterProd.toLowerCase() + '.*').test(prod.name.toLowerCase())
        return check
      })
    },
    countProds () {
      let len = 0
      if (this.brandsOptions[this.tabIndex] !== undefined) {
        if (this.brandsOptions[this.tabIndex].cats.nodes[this.catId]) {
          len += this.brandsOptions[this.tabIndex].cats.nodes[this.catId].prods ? this.brandsOptions[this.tabIndex].cats.nodes[this.catId].prods.nodes.length : 0
        }
      }
      return len
    },
    permitCancelOrder () {
      return this.order &&
          this.order.status.keyword !== STATUS_ORDER.PASSED &&
          this.order.status.keyword !== STATUS_ORDER.END &&
          this.order.status.keyword !== STATUS_ORDER.CANCELED
    }
  }
}
</script>

<style lang="scss" scoped>
    .brunch__text_input:focus {
      box-shadow: 0 0px 2px rgba(0, 0, 0, 0.15);
    }
    .slide-fade-enter-active {
      transition: all .1s ease-in;
    }
    .slide-fade-leave-active {
      transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to {
      transform: translateX(5px);
      opacity: 0;
    }

    .slide-fade-from-bottom-enter-active {
      transition: all .1s ease-in;
    }
    .slide-fade-from-bottom-leave-active {
      transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-from-bottom-enter, .slide-fade-from-bottom-leave-to {
      transform: translateX(5px);
      opacity: 0;
    }

    .orders-count-title {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .two-digit-inp {
        width: 65px;
        text-align: center;
        display: inline-block;
    }
    .promocodeOnlyMobile {
      color: grey;
    }
    .grid {
        display: grid;
    }

    .grid-3 {
        grid-template-columns: repeat(3, 1fr);
        > .card:nth-child(3n + 1) {
            border-left: 1px solid rgba(0, 0, 0, 0.125);;
        }
    }

    .categories {
        display: flex;
        justify-content: flex-start;
        flex-grow: 1;
        flex-wrap: wrap;
        > * {
            width: calc(25% - 0.5rem);
            cursor: pointer;
            &:hover {
                background: #DBEAB4;
            }
            > span {
                margin: auto;
            }
        }
        > .active {
            background: #eeffc4;
        }
    }
    .products {
      > * {
            cursor: pointer;
            &:hover {
                background: #DBEAB4;
            }
            > span {
                margin: auto;
            }
        }
    }

    tr.order-prods td {
        vertical-align: middle;
    }

    .checkbox-header {
        line-height: 1.5;
    }

    .description {
        cursor: pointer;
    }

    .table-orders {
        border-bottom: 1px solid #DFDFDF;
    }

    .round-btn {
        border-radius: 100%;
        border: none;
    }

    .flex-tab > .active {
        display: flex;
        flex-direction: column;
    }

    .priceOrder {
        flex-basis: 230px;
    }

    .inputSize {
        font-size: 1rem;
    }

    .input_
    #collapseOrders {
        border-bottom: 1px solid #DFDFDF;
    }

    .order {
      padding: 0;
      cursor: pointer;
      &:hover {
          background: #DBEAB4;
      }
      &.activeIt {
          background: #eeffc4;
      }
    }

    .table-prod-name {
        max-width: 500px;
    }

    .confirmOrder {
        background: #b3dfff;
    }

    .promocode-icon {
        width: 50px;
        height: 32px;
        color: red;
    }

    .delivery-cost {
      padding-left: 20px;
      font-size: 20px;
    }

    .delivery-cost_error {
      border-left: 8px solid red;
    }

    .delivery-cost_success {
      border-left: 8px solid green;
    }

    .scroll-postiton-variants {
      max-height: 200px;
    }

    .info-suggest-not-found, .info-suggest-error{
      font-size: 18px;
    }
    .v-select.drop-up.vs--open .vs__dropdown-toggle {
      border-radius: 0 0 4px 4px;
      border-top-color: transparent;
      border-bottom-color: rgba(60, 60, 60, 0.26);
    }

    [data-popper-placement='top'] {
      border-radius: 4px 4px 0 0;
      border-top-style: solid;
      border-bottom-style: none;
      box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
    }

    .street-error {
      font-size: 12px;
      line-height: 120%;
      color: red;
    }
</style>



// WEBPACK FOOTER //
// src/components/OrderInfo.vue